/**
  * 算法实现：
  * 1、首先取ABC对应的ASCII码值。A（65）B（66）C（67）；
    2、再取二进制值A（01000001）B（01000010）C（01000011）；
    3、然后把这三个字节的二进制码接起来（010000010100001001000011）；
    4、 再以6位为单位分成4个数据块,并在最高位填充两个0后形成4个字节的编码后的值，（00010000）（00010100）（00001001）（00000011），其中蓝色部分为真实数据；
    5、再把这四个字节数据转化成10进制数得（16）（20）（9）（3）；
    6、最后根据BASE64给出的64个基本字符表，查出对应的ASCII码字符（Q）（U）（J）（D），这里的值实际就是数据在字符表中的索引。
    注：BASE64字符表：ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/
  */
/**
 * Base64-encodes a string of text.
 * @param {String} text The text to encode.
 * @return {String} The base64-encoded string.
 */
var Base64 = {
    DIGITS: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
    encode:function(text){
        if (/([^\u0000-\u00ff])/.test(text)){
            throw new Error("Can't base64 encode non-ASCII characters.");
        }   
        var digits = this.DIGITS,i = 0,cur, prev, byteNum,result=[];      
        while(i < text.length){
            cur = text.charCodeAt(i);
            byteNum = i % 3;
            switch(byteNum){
                case 0: //first byte
                    result.push(digits.charAt(cur >> 2));
                    break;
                case 1: //second byte
                    result.push(digits.charAt((prev & 3) << 4 | (cur >> 4)));
                    break;
                case 2: //third byte
                    result.push(digits.charAt((prev & 0x0f) << 2 | (cur >> 6)));
                    result.push(digits.charAt(cur & 0x3f));
                    break;
            }
            prev = cur;
            i++;
        }
        if (byteNum == 0){
            result.push(digits.charAt((prev & 3) << 4));
            result.push("==");
        } else if (byteNum == 1){
            result.push(digits.charAt((prev & 0x0f) << 2));
            result.push("=");
        }
        return result.join("");  
    },
    /**
     * Base64-decodes a string of text.
     * @param {String} text The text to decode.
     * @return {String} The base64-decoded string.
     */
    decode:function(text){
        //ignore white space
        text = text.replace(/\s/g,"");   
        //first check for any unexpected input
        if(!(/^[a-z0-9\+\/\s]+\={0,2}$/i.test(text)) || text.length % 4 > 0){
            throw new Error("Not a base64-encoded string.");
        }    
        //local variables
        var digits = this.DIGITS,cur, prev, digitNum,i=0,result = [];
        //remove any equals signs
        text = text.replace(/=/g, "");
        //loop over each character
        while(i < text.length){
            cur = digits.indexOf(text.charAt(i));
            digitNum = i % 4;
            switch(digitNum){
                //case 0: first digit - do nothing, not enough info to work with 
                case 1: //second digit
                    result.push(String.fromCharCode(prev << 2 | cur >> 4));
                    break;   
                case 2: //third digit
                    result.push(String.fromCharCode((prev & 0x0f) << 4 | cur >> 2));
                    break;      
                case 3: //fourth digit
                    result.push(String.fromCharCode((prev & 3) << 6 | cur));
                    break;
            }
            prev = cur;
            i++;
        }
        //return a string
        return result.join("");
    } 
};


String.prototype.format = function() {
    var args = arguments
    var str = this
    var pattern = new RegExp('{([0-' + args.length + '])}', 'g')
    return String(str).replace(pattern, function(match, index) {
        return args[index]
    })
}

if (typeof constant == 'undefined') {
    constant = {}
}
var Login = {
    ERROR_TIPS: '_error_tips',
    RETURN_CODE: 'code',
    USERID_DM: 'userid_dm',
    DOMAIN_DM: 'domain_dm',
    LOGINTYPE_DM: 'logintype_dm',
    USER_PWDTYPE: 'user_pwdType',
    ADDRESS_SELECT: 'address_select',
    REMEMBERUSER_DM: 'rememberuser_dm',
    SSL: 'ssl',
    REPLY_LOGIN: 8,
    waitStatus: true,
    init: function(obj, reg, len, func) {
        this.isProvince = obj.isProvince
        this.code = GC.getUrlParamValue(location.href, this.RETURN_CODE)
        this.oUsernumber = jQuery('#' + obj.usernumber)
        this.oUserId = jQuery('#' + obj.userid)
        this.oDomain = jQuery('#' + obj.domain)
        this.oPassword = jQuery('#' + obj.password)
        this.oCheckCode = jQuery('#' + obj.checkCode)
        this.oRemember = jQuery('#' + obj.remember)
        this.oErrorTip = jQuery('#' + obj.errorTip)
        this.oSsl = jQuery('#' + obj.ssl)
        this.oReturnurl = jQuery('#' + obj.returnurl)
        this.oAddrSel = jQuery('#' + obj.addrsel)
        this.oForm = jQuery('#' + obj.form)
        this.oPasswordType = jQuery('#' + obj.passwordType)
        this.oAddrPop = jQuery(obj.addrPop)
        this.func = func
        this.jtUid = obj.jtUid
        this.jtCorpDomain = obj.jtCorpDomain
        this.isStandard = obj.isStandard
        this.realDomain = obj.realDomain
        this.oMobileNumber = jQuery('#' + obj.mobileNumber)
        this.oModel = jQuery('#' + obj.model)
        if (obj.ym) {
            this.oYm = jQuery('#' + obj.ym)
        }
        this.oIsAdminLogin = jQuery('#userLogin')[0]

        // 标准版
        this.oUserLogin = jQuery('#' + obj.userLogin)
        this.oAdminLogin = jQuery('#' + obj.adminLogin)
        this.oKeyLogin = jQuery('#' + obj.keyLogin)
        this.oLoginType = jQuery('#' + obj.loginType)

        //初始化验证数据
        this.reg = reg
        this.len = len

        //数据集
        this.attrs = {}

        var p = this
        if (p.oReturnurl.val() == '') {
            var url = window.location.href
            if (url.indexOf('?') > 0) url = url.substring(0, url.indexOf('?'))
            p.oReturnurl.val(url)
        }
        p.attrs['panel'] = GC.getCookie('panel') || 1

        p.oForm.submit(function() {
                return p.validate()
            })
            // 初始化输入控件宽度
        if (this.isDomainMode()) {
            if (this.oYm.width()) {
                var lic = jQuery('#liUserNum')
                if (lic && lic.width()) {
                    var usernumberWidth = lic.width() - this.oYm.width() - 50
                    if (usernumberWidth <= 60) {
                        usernumberWidth = 60
                    }
                    this.oUsernumber.width(usernumberWidth)
                }
            }
        }

        // 计算高度
        //        var docHeight = jQuery(document.body).height();
        //        var mt = 0;
        //        if(docHeight){
        //            var extraHeight = docHeight - 450;
        //            if(extraHeight > 0){
        //                mt = parseInt(extraHeight / 2);
        //            }
        //        }
        //        jQuery('.header:eq(0)').css({
        //           "margin-top": mt + 'px'
        //        });

        p.bindEvent()
        p.tempDomains = domains || []
        Login.initLoginPanner()
            //cookie设置登录
        Login.initData(p.code)

        //初始化验证码事件
        Login.initEvent()
            //提示登录错误信息
        Login.showError('', p.code)
    },
    isDomainMode: function() {
        if (this.oYm && this.oYm.length) {
            return true
        }
        return false
    },

    //根据输入框内容存在与否显示输入框提示内容
    setNameTip: function() {
        var userName = jQuery('#usernumber').val()
        if (userName == '') {
            $('#mail_acotip').show()
        } else {
            $('#mail_acotip').hide()
        }
        var pwd = jQuery('#password').val()
            //是公共邮箱登录的情况
        if (window.location.href.indexOf('pmlogin.do') != -1) {
            if (pwd == '') {
                $('#mail_pswtip').show()
            } else {
                $('#mail_pswtip').hide()
            }
        } else {
            if (pwd == '' && $('#userLogin').hasClass('on')) {
                $('#mail_pswtip').show()
            } else {
                $('#mail_pswtip').hide()
            }
        }
        var code = jQuery('#checkCode').val()
        if (code == '' && $('#adminLogin').hasClass('on')) {
            $('#mail_smstip').show()
        } else {
            $('#mail_smstip').hide()
        }
        /*var keyPwd = jQuery("#KeyPassWordDiv").val();
		if (keyPwd=="") {
			$('#ukey_pin').show();
		} else {
			$('#ukey_pin').hide();
		}*/
    },
    /**
     * 绑定事件
     */
    bindEvent: function() {
        var p = this
            // 回车事件
        p.oForm.keypress(function(event) {
            if (event.keyCode == '13') {
                if ((p.oUsernumber.val() || p.oUserId.val()) && p.oPassword.val()) {
                    // 记忆用户面板信息
                    if (p.attrs && p.attrs['panel']) {
                        p.setCookie()
                    }
                    if (jQuery('#loginPannel').is(':visible')) {
                        //解决在用enter选择下拉框选择域名时候提交表单显示地址错误，当用enter选择邮箱域名的时候不做提交只选择
                    } else {
                        p.doSubmit()
                    }
                    // p.doSubmit();
                }
            }
        })
        setTimeout(function() {
            p.setNameTip()
        }, 1)
        $('#usernumber').keydown(function(event) {
            setTimeout(function() {
                p.setNameTip()
            }, 1)
        })

        $('#KeyPassWordDiv').keydown(function(event) {
            setTimeout(function() {
                p.setNameTip()
            }, 1)
        })

        $('#password').keydown(function(event) {
            setTimeout(function() {
                p.setNameTip()
            }, 1)
        })

        $('#checkCode').keydown(function(event) {
            setTimeout(function() {
                p.setNameTip()
            }, 1)
        })

        if (!this.isDomainMode()) {
            $('#usernumber').keyup(function(event) {
                p.tempDomains = []
                var userName = jQuery('#usernumber')[0].value
                var arrayName = userName.split('@')
                var sufUserName //邮箱后缀
                if (arrayName.length > 1) {
                    sufUserName = arrayName[1]
                    sufUserName = sufUserName.replace(/\./g, '\\.') //"."转义为"\."
                }
                for (var i = 0; i < domains.length; i++) {
                    var reg = new RegExp('^' + sufUserName + '', 'g')
                    if (domains[i].match(reg)) {
                        p.tempDomains.push(domains[i])
                    }
                }
                p.initLoginPanner()
                p.showPannel(event)
                jQuery('#pwdBox').addClass('loginIpt-focus')

                p.selectLiId = p.getSelectedLoginId()

                var listPannels = jQuery('#loginPannel')[0]
                var heightLi = 0
                if (listPannels) {
                    heightLi = jQuery(listPannels.childNodes[0]).height()
                    if (heightLi < 22) {
                        //为了美观，采用非常规手段处理：由于UI给的LI高度不同，ie和firefox下计算li高度为22，chrome下计算出来为21.111112594604492
                        heightLi = 21.111112594604492
                    }
                }

                var heightPannel = heightLi * 10
                if (event.keyCode == 40) {
                    //向上键
                    p.selectLiId++
                        if (p.selectLiId * heightLi >= heightPannel) {
                            jQuery('#loginPannel')[0].scrollTop = (p.selectLiId + 1) * heightLi - heightPannel
                        }
                    if (p.selectLiId == p.tempDomains.length) {
                        jQuery('#loginPannel')[0].scrollTop = 0
                        jQuery('#loginPannel')
                            .children('li .loginSelected')
                            .removeClass('loginSelected')
                        p.selectLiId = 0
                        listPannels.childNodes[p.selectLiId].className = 'loginSelected'
                    } else {
                        jQuery('#loginPannel')
                            .children('li .loginSelected')
                            .removeClass('loginSelected')
                        listPannels.childNodes[p.selectLiId].className = 'loginSelected'
                    }
                }

                if (event.keyCode == 38) {
                    //向下键
                    p.selectLiId--
                        if (jQuery('#loginPannel')[0].scrollTop >= 0) {
                            jQuery('#loginPannel')[0].scrollTop = (p.selectLiId + 1) * heightLi - heightPannel
                        }
                    if (p.selectLiId == -1) {
                        p.selectLiId = p.tempDomains.length - 1
                        jQuery('#loginPannel')[0].scrollTop = (p.selectLiId + 1) * heightLi - heightPannel
                        jQuery('#loginPannel')
                            .children('li .loginSelected')
                            .removeClass('loginSelected')
                        listPannels.childNodes[p.selectLiId].className = 'loginSelected'
                    } else {
                        jQuery('#loginPannel')
                            .children('li .loginSelected')
                            .removeClass('loginSelected')
                        listPannels.childNodes[p.selectLiId].className = 'loginSelected'
                    }
                }
                //回车
                if (event.keyCode == '13') {
                    setTimeout(function() {
                        p.inputFinish()
                            // return false;
                    }, 10)
                }
            })
        }
        //密码框获取焦点时，隐藏登录下拉框
        $('#password').focus(function(event) {
            p.hideLoginPannel()
            jQuery('#pwdBox').addClass('loginIpt-focus')
            jQuery('#userNumBox').removeClass('loginIpt-focus')
        })

        //短信验证码框获取焦点时，隐藏登录下拉框
        $('#checkCode').focus(function(event) {
            p.hideLoginPannel()
            jQuery('#pwdBox').addClass('loginIpt-focus')
            jQuery('#userNumBox').removeClass('loginIpt-focus')
        })

        //获取验证码按钮
        jQuery('#btncode').click(function(e) {
            var p = Login
            var code = ''
            var param = ''
            var field = 'userid'
            var btn = document.getElementById('btncode')
            var un = jQuery.trim(p.oUsernumber.val())
                //校验手机号码  需要加err code
            if (!un || !un.match(p.reg.mobile)) {
                code = 'err_phoneNumber_error'
                isOk = false
                p.showError(field, code, param)
                return false
            } else {
                btn.value = Lang.Mail.Config.verifyCodeIsSending
                $('#btncode').addClass('disable')
                var getUrl = 'getcheckcode.do?mobilePhone=' + un + '&rd=' + Math.random()
                $.ajax({
                    type: 'GET',
                    url: getUrl,
                    dataType: 'json',
                    success: function(data) {
                        if (data.code == 'S_OK') {
                            btn.value = Lang.Mail.Config.sendSuc
                            CountDown.init(btn)
                        } else {
                            btn.value = Lang.Mail.Config.getVerifyCode
                            btn.className = 'getCodeBtn'
                            $('#errorTips')
                                .text(data.summary)
                                .show()
                        }
                    },
                    error: function() {
                        btn.value = Lang.Mail.Config.getVerifyCode
                        btn.className = 'getCodeBtn'
                        $('#errorTips')
                            .text(Lang.Mail.Config.getVerifyCodeFailPleaseReget)
                            .show()
                    }
                })
            }
        })

        //usernumber
        //用户名框获取焦点时，隐藏登录下拉框
        $('#usernumber').focus(function(event) {
            p.hideLoginPannel()
            jQuery('#pwdBox').removeClass('loginIpt-focus')
            jQuery('#userNumBox').addClass('loginIpt-focus')
        })

        $('#liUserNum').click(function(event) {
            if (!p.isDomainMode()) {
                p.initLoginPanner()
                p.showPannel(event)
                jQuery('#userNumBox').addClass('loginIpt-focus')
                jQuery('#pwdBox').removeClass('loginIpt-focus')
            }
        })
        $('#LoginMode').mouseover(function() {
            var modeChildren = jQuery('#loginModePannel').children()
            if (modeChildren[0] && power_mail != true) {
                jQuery(modeChildren[0]).hide()
            }
            if (modeChildren[1] && power_disk != true) {
                jQuery(modeChildren[1]).hide()
            }
            if (modeChildren[2] && power_contacts != true) {
                jQuery(modeChildren[2]).hide()
            }
            if (modeChildren[3] && power_schedule != true) {
                jQuery(modeChildren[3]).hide()
            }

            //jQuery("#loginModePannel").children()[0];

            jQuery('#modePannel').removeClass('fake_slt_off')
            jQuery('#modePannel').addClass('fake_slt_on')

            jQuery('#userNumBox').removeClass('loginIpt-focus')
            jQuery('#pwdBox').removeClass('loginIpt-focus')

            var loginModePannel = $('#loginModePannel')
            if (loginModePannel.length > 0) {
                loginModePannel.show()
                p.loginModePannel = loginModePannel
            }
            if (power_mail != true && power_disk != true && power_contacts != true && power_schedule != true) {
                loginModePannel.hide()
            }
            return false
        })

        $('#LoginMode').mouseout(function() {
                jQuery('#modePannel').removeClass('fake_slt_on')
                jQuery('#modePannel').addClass('fake_slt_off')
                jQuery('#modePannel').removeClass('fake_slt_on')
                p.loginModePannel.hide()
                return false
            })
            /*
                                 $("#LoginMode").click(function(){
                                 jQuery("#userNumBox").removeClass("loginIpt-focus");
                                 jQuery("#pwdBox").removeClass("loginIpt-focus");
                                 var loginModePannel = $("#loginModePannel");
                                 if (loginModePannel.length >0) {
                                 loginModePannel.show();
                                 p.loginModePannel = loginModePannel;
                                 }
                                 return false;
                                 });
                                 */
        $('#loginModePannel').click(function(event) {
            if (event.target) {
                jQuery('#showMode')[0].innerHTML = event.target.parentNode.innerHTML
                var mode = event.target.parentNode.getAttribute('rel')
                p.oModel.val(mode)
            }
            p.loginModePannel.hide()
            if (event.stopPropagation) {
                event.stopPropagation()
            } else {
                event.cancelBubble = true
            }
            return false
        })

        $('body').click(function() {
            p.hideLoginPannel()
            if (p.loginModePannel) {
                p.loginModePannel.hide()
            }
            jQuery('#modePannel').removeClass('fake_slt_on')
        })
    },
    getSelectedLoginId: function() {
        var selectedLi = jQuery('#loginPannel').children('li .loginSelected')[0]
        if (selectedLi && selectedLi.childNodes[0]) {
            return selectedLi.childNodes[0].getAttribute('rel') - 0
        }
        return '-1'
    },
    hideLoginPannel: function() {
        var p = this
        if (p.loginPannel) {
            p.loginPannel.hide()
        }
        jQuery('#loginPannel')
            .children('li .loginSelected')
            .removeClass('loginSelected')
    },
    /**
     * 构造登录下拉框
     */
    initLoginPanner: function() {
        var p = this
        var pannel = jQuery('#loginPannel')[0]
        if (pannel) {
            pannel.innerHTML = ''
                //document.body.removeChild(pannel);
        }
        var userName = jQuery('#usernumber')[0].value
        if (userName.split('@').length > 1) {
            userName = userName.split('@')[0]
        }
        var tempLen = p.tempDomains.length
        var tempHtml = ''
            //tempHtml += '<ul><li class="note">请选择邮箱类型</li></ul>';
            //tempHtml += '<ul>';
        for (var i = 0; i < tempLen; i++) {
            var item = p.tempDomains[i]
            if (i == p.selectLiId) {
                tempHtml += '<li class="loginSelected"><a rel=' + i + ' href="#">' + userName + '@' + item + '</a></li>'
            } else {
                tempHtml += '<li><a rel=' + i + ' href="#">' + userName + '@' + item + '</a></li>'
            }
        }

        //tempHtml += '</ul>';
        //var pannelContainer =  document.createElement("div");

        //pannelContainer.id = "loginPannel";
        //pannelContainer.className = "layer_menu_list layer_login_pannel";
        if (pannel) {
            pannel.innerHTML = tempHtml
        }

        //document.body.appendChild(pannelContainer);
        jQuery('#loginPannel').click(function(e) {
            var target = e.target || e.srcElement
            var index = target.getAttribute('rel')
            if (index) {
                var userName = jQuery('#usernumber')[0].value
                if (userName.split('@').length > 1) {
                    userName = userName.split('@')[0]
                }
                jQuery('#usernumber')[0].value = userName + '@' + p.tempDomains[index]
            }
            p.hideLoginPannel()
        })
    },
    inputFinish: function() {
        var selectLi = jQuery('#loginPannel').children('.loginSelected')
        if (selectLi && selectLi[0] && selectLi[0].childNodes) {
            jQuery('#usernumber')[0].value = selectLi[0].childNodes[0].innerHTML
        }
        this.hideLoginPannel()
    },
    /**
     * 域名是否输入完成
     */
    isInputFinish: function(sufInputNum) {
        if (sufInputNum == '') {
            return true
        } else {
            var reg = new RegExp('(^|,)' + sufInputNum + '(,|$)')
            if (reg.test(domains)) {
                return false
            }
            return true
        }
    },
    /**
     * 显示登录下拉框
     */
    showPannel: function(ev) {
        var p = this
        if (!this.isPhoneLogin) {
            var loginPannel = jQuery('#loginPannel')
            var inputNum = jQuery('#usernumber')[0].value
            var subInputNum
            var sufInputNum
            var arrayTemp = inputNum.split('@')
            if (arrayTemp.length > 1) {
                subInputNum = arrayTemp[0] //前缀admin
                sufInputNum = arrayTemp[1] //后缀se.com
            }

            //匹配域名后缀.com，.cn，.org，.info，.net
            //包含"@"，不以"@"开头，只能包含一个"@"，不宜域名结尾，则显示
            //if (loginPannel[0] && inputNum.match(/\@/ig) && !inputNum.match(/^\@/ig)&& inputNum.match(/\@/ig).length == 1 && (!sufInputNum.match(/.\...+/) || !sufInputNum.match(/.com$|cn$|.org$|.net$|.info$|.rac$/))) {
            if (
                loginPannel[0] &&
                inputNum.match(/\@/gi) &&
                !inputNum.match(/^\@/gi) &&
                inputNum.match(/\@/gi).length == 1 &&
                p.isInputFinish(sufInputNum)
            ) {
                loginPannel.show()
                    //loginPannel[0].style.top = jQuery("#login_ul").offset().top - 0 + 43 + "px";
                    //loginPannel[0].style.left = jQuery("#login_ul").offset().left - 1 + "px";
                this.loginPannel = loginPannel
                    //var tempPannels = loginPannel.find("a[rel]");
                    //for (var i = 0; i< p.tempDomains.length; i++) {
                    //	tempPannels[i].innerHTML = subInputNum +"@"+ p.tempDomains[i];
                    //}
                if (22 * p.tempDomains.length < 212) {
                    loginPannel[0].style.height = 22 * p.tempDomains.length + 'px'
                } else {
                    loginPannel[0].style.height = '212px'
                }
            }
            if (p.tempDomains.length < 1) {
                if (p.loginPannel) {
                    p.loginPannel.hide()
                }
            }

            p.selectLiId = p.getSelectedLoginId()
            var listPannels = jQuery('#loginPannel')[0]
            if (listPannels && listPannels.childNodes.length > 0) {
                if (p.selectLiId == '-1') {
                    listPannels.childNodes[0].className = 'loginSelected'
                } else if (p.selectLiId > -1) {
                    listPannels.childNodes[p.selectLiId].className = 'loginSelected'
                }
            }
        }

        //阻止默认行为和阻止冒泡
        if (ev.stopPropagation) {
            ev.stopPropagation()
        } else {
            ev.cancelBubble = true
        }
        if (ev.preventDefault) {
            ev.preventDefault()
        } else {
            ev.returnValue = false
        }
    },
    /**
     * 初始化事件
     */
    initEvent: function() {
        var $ = jQuery,
            p = this

        //如果错误验证码p.code  表示需要输入验证码
        //需要修改，暂时为true
        if (p.code === 'err_005' || p.code === 'err_006') {
            //验证码展示
            $('#li_verifyCode').show()
            $('#loginContainer')
                .removeClass('login')
                .addClass('login-verifyCode')
            p.refreshImgRndCode()

            p.inint_verifyEvent()

            //增加高度
            //$("#login_div").css("height","389px");
        }

        //绑定登录事件
        $('#login_otp')
            .off('click')
            .on('click', p.doSubmit)
    },
    inint_verifyEvent: function() {
        var $ = jQuery,
            p = this

        //图片验证码点击后 ，输入框选中
        $('#mail_vctip').click(function() {
            $('#txtVerifyCode').focus()
        })

        //提示的显示与隐藏
        $('#txtVerifyCode')
            .unbind()
            .bind('keyup', function() {
                if (
                    $(this)
                    .val()
                    .replace(/^\s+/, '')
                    .replace(/\s+$/, '') == ''
                ) {
                    $('#mail_vctip').show()
                    $(this).css('color', '#bebebe')
                } else {
                    $('#mail_vctip').hide()
                    $(this).css('color', '#000000')
                }
            })
    },

    /**
     * 变更验证图片
     */
    refreshImgRndCode: function() {
        //  获得src ,传一个数据数
        var $ = jQuery

        $('#imgRnd')[0].src = constant.imgUrl + '?r=' + new Date().getTime()
    },

    /**
     * 显示地址选择框
     */
    showAddressPop: function() {
        Login.oAddrPop.fadeIn('slow')
    },

    /**
     * 隐藏地址选择框
     */
    hideAddressPop: function() {
        Login.oAddrPop.fadeOut('slow')
    },

    /**
     * 设置域名
     */
    setDomain: function(t) {
        var p = this
        var domain = t.id
            /*
                                 var un_v = p.oUsernumber.val();
                                 if (un_v && un_v.indexOf("@") > -1) {
                                 p.oUsernumber.val(un_v.substring(0,un_v.indexOf("@") + 1) + domain);
                                 } else if (un_v) {
                                 p.oUsernumber.val(un_v + "@" + domain);
                                 }
                                 */
        var pn = $(t).text()
        p.oAddrSel.html(pn + '<i></i>').attr('sd', domain)
        if (pn.length == 3) {
            p.oAddrSel.addClass('three-word')
        } else {
            p.oAddrSel.removeClass('three-word')
        }
    },

    initData: function(code) {
        // 初始化表单信息
        var p = Login
        var uid = GC.getCookie(p.USERID_DM)
        var domain = GC.getCookie(p.DOMAIN_DM) || ''
        var rememberuser_dm = GC.getCookie(p.REMEMBERUSER_DM)
        var pId = GC.getCookie(p.ADDRESS_SELECT)
        var ssl = GC.getCookie(p.SSL)
        var pwdType = GC.getCookie(p.USER_PWDTYPE)
        var panel = GC.getCookie('panel')

        p.attrs['mail'] = GC.getCookie('mailAccount')
        p.attrs['phone'] = GC.getCookie('phoneAccount')

        /*
         if(panel && panel.toString() == "2"){
         p.adminLogin();
         }
         else if(panel && panel.toString() == "1"){
         p.userLogin();
         }

         if (panel == "1") {
         p.oUsernumber.val(p.attrs['mail']);
         } else if (panel == "2") {
         p.oUsernumber.val(p.attrs['phone']);
         }
         */
        if (rememberuser_dm == 'true') {
            if (p.isDomainMode()) {
                p.oUsernumber.val(uid)
            } else {
                if (p.isStandard && uid) {
                    if (domain == '') {
                        p.oUsernumber.val(uid)
                    } else if (p.realDomain) {
                        p.oUsernumber.val(uid)
                    } else {
                        p.oUsernumber.val(uid + '@' + domain)
                    }
                } else if (uid && p.isProvince) {
                    p.oUsernumber.val(uid)
                } else if (uid) {
                    p.oUsernumber.val(uid)
                }
            }
            p.oRemember.attr('checked', true)
            if (ssl == 'true') {
                p.oSsl.attr('checked', true)
            }
            if (p.oAddrSel && pId) {
                setProvince()
            }
            /*
             if(panel && panel.toString() == "2"){
             p.oUsernumber.val(p.attrs['phone']);
             p.adminLogin();
             }
             else if(panel && panel.toString() == "1"){
             p.oUsernumber.val(p.attrs['mail']);
             p.userLogin();
             }
             */
        } else if (Login.realDomain) {
            pId = Login.realDomain
            setProvince()
        }
        if (panel && panel.toString() == '2') {
            p.oUsernumber.val(p.attrs['phone'])
                // p.adminLogin();
        } else if (panel && panel.toString() == '1') {
            p.oUsernumber.val(p.attrs['mail'])
            p.userLogin()
        }
        if (panel == '1') {
            p.oUsernumber.val(p.attrs['mail'])
        } else if (panel == '2') {
            p.oUsernumber.val(p.attrs['phone'])
        }
        if (code) {
            if (p.isDomainMode()) {
                //p.oUsernumber.val(uid);
            } else {
                if (p.isStandard && uid) {
                    if (domain == '') {
                        p.oUsernumber.val(uid)
                    } else if (p.realDomain) {
                        p.oUsernumber.val(uid)
                    } else {
                        p.oUsernumber.val(uid + '@' + domain)
                    }
                }
                // 省份登录页
                else if (uid && p.isProvince) {
                    p.oUsernumber.val(uid)
                } else if (uid) {
                    if (!p.isDomainMode() && (!p.panel || '1' == p.panel)) {
                        p.oUsernumber.val(uid + '@' + domain)
                    } else {
                        p.oUsernumber.val(uid)
                    }
                }
            }

            if (p.oAddrSel && pId) {
                setProvince()
            }
            if (ssl == 'true') {
                p.oSsl.attr('checked', true)
            }
            if (pwdType == '1') {
                TC.userDynamicPwd()
                TC.oOtpTip.show().addClass('pb18')
                TC.oPassword
                    .removeAttr('disabled')
                    .focus()
                    .removeClass('log_txt_unable')
                    .addClass('log_txt')
                    .css({ 'box-shadow': '1px 2px 1px #E3E3E3 inset' })
                    .parent('li')
                    .removeClass('pb18')
                TC.oLoginBtn.attr('href', 'javascript:doLogin();')
                TC.oLoginText.text(Lang.Mail.Config.login)
            }
        } else {
            if (!p.oRemember.is(':checked')) {
                p.oUsernumber.val('')
            }
        }

        function setProvince() {
            var rpId = pId.replace(/\./g, '\\.')

            if ($('#' + rpId).text()) {
                var pn = $('#' + rpId).text()
                p.oAddrSel.attr('sd', pId).html(pn + '<i></i>')

                if (pn.length == 3) {
                    p.oAddrSel.addClass('three-word')
                } else {
                    p.oAddrSel.removeClass('three-word')
                }
            }
        }

        // 初始化登陆模块默认值
        var powerList = [
            typeof power_mail != 'undefined' ? power_mail : false,
            typeof power_disk != 'undefined' ? power_disk : false,
            typeof power_contacts != 'undefined' ? power_contacts : false,
            typeof power_schedule != 'undefined' ? power_schedule : false
        ]
        var found = false
        for (var i = 0; i < powerList.length; i++) {
            if (!found && powerList[i]) {
                var node = jQuery('#loginModePannel li:eq(' + i + ')')
                jQuery('#showMode').html(node.html())
                var mode = node.attr('rel')
                p.oModel.val(mode)
                found = !found
            }
        }
    },
    setCookie: function() {
        // 记住用户名
        var p = Login
        var path = window.webpath
        var exp = new Date()
        exp.setTime(exp.getTime() + 14 * 24 * 60 * 60 * 1000)
        GC.setCookie(p.USERID_DM, p.oUserId.val(), path, null, exp)
        GC.setCookie(p.DOMAIN_DM, p.oDomain.val(), path, null, exp)
        GC.setCookie(p.USER_PWDTYPE, p.oPasswordType.val(), path, null, exp)
        if (p.attrs && p.attrs['panel']) {
            GC.setCookie('panel', p.attrs['panel'], path, null, exp)
        }

        if (p.attrs['panel'] == '1') {
            GC.setCookie('mailAccount', p.oUsernumber.val(), path, null, exp)
        }

        if (p.attrs['panel'] == '2') {
            GC.setCookie('phoneAccount', p.oUsernumber.val(), path, null, exp)
        }

        if (p.oAddrSel) {
            GC.setCookie(p.ADDRESS_SELECT, p.oAddrSel.attr('sd'), path, null, exp)
        }

        if (p.oRemember.is(':checked')) {
            GC.setCookie(p.REMEMBERUSER_DM, 'true', path, null, exp)
        } else {
            GC.setCookie(p.REMEMBERUSER_DM, 'false', path, null, exp)
        }

        if (p.oSsl.is(':checked')) {
            GC.setCookie(p.SSL, 'true', path, null, exp)
        } else {
            GC.setCookie(p.SSL, 'false', path, null, exp)
        }
        GC.setCookie('isFirstLogin', '', path, null, exp)
    },
    doSubmit: function() {
        var p = Login
        if (!p.oIsAdminLogin) {
            p.oLoginType.val('ADMIN')
        } else {
            p.oLoginType.val('WEB')
        }
        //TODO: 获取公钥
        if (window.top.isEncryptPwd == '1') {
            RSAKey &&
                RSAKey.getPublicKey(function(publicKey) {
                    window.top.publicKey = publicKey
                    p.oForm.submit()
                }, true)
        } else {
            p.oForm.submit()
        }
    },
    //数据验证
    validate: function() {
        var p = Login
        var un = jQuery.trim(p.oUsernumber.val())
        var uid = un
        var dd = window.defaultDomain || ''
        p.oErrorTip.hide()

        if (!p.isPhoneLogin && /^[\w-\.]+@\w+(\.[a-zA-Z]+)+$/.test(un) === false) {
            if (p.realDomain.length > 0) {
                uid = un + '@' + p.realDomain
            } else if (window.defaultDomain.length > 0) {
                uid = un + '@' + window.defaultDomain
            }
        }

        // 标准版
        if (p.isStandard) {
            var arr = uid.split('@')
            if (arr) {
                p.oUserId.val(jQuery.trim(arr[0]) || '')
                p.oDomain.val(jQuery.trim(arr[1]) || p.oAddrSel.attr('sd') || '')
            }
        }
        // 省份的登录页
        else if (p.isProvince) {
            p.oUserId.val(un || '')
                // 全国登录页
        } else {
            if (un) {
                var arr = un.split('@')
                if (arr) {
                    p.oUserId.val(jQuery.trim(arr[0]) || '')
                    if (!arr[1] && p.oDomain) {
                        p.oDomain.val(p.realDomain)
                    } else {
                        p.oDomain.val(jQuery.trim(arr[1]) || p.oAddrSel.attr('sd') || '')
                    }
                }
            } else {
                p.oUserId.val('')
                p.oDomain.val('')
            }
        }

        var userid_v = p.oUserId.val()
        var domain_v = p.oDomain.val()
        var password_v = p.oPassword.val()
        var checkCode_v = p.oCheckCode.val()

        var code = ''
        var param = ''
        var field = ''
        var isOk = true
        var len = p.len
        var $ = jQuery

        // 校验用户id
        if (userid_v.length == 0) {
            code = 'err_003'
            isOk = false
        } else if (userid_v.length > len.userid_max) {
            code = 'err_004'
            param = len.userid_max
            isOk = false
        } else if (!userid_v.match(p.reg.userid)) {
            code = 'err_004'
            isOk = false
        }
        field = 'userid'

        // 邮箱帐号登录，校验域名
        if (isOk && !p.isPhoneLogin) {
            if (domain_v.length == 0) {
                code = 'err_001'
                isOk = false
            } else if (domain_v.length > len.domain_max) {
                code = 'err_010'
                param = len.domain_max
                isOk = false
            } else if (!domain_v.match(p.reg.domain)) {
                code = 'err_010'
                isOk = false
            }
            field = 'domain'
        }

        p.oMobileNumber.val(un || '')
            //校验手机号码  需要加err code
        if (p.isPhoneLogin && !un.match(p.reg.mobile)) {
            code = 'err_009'
            isOk = false
        }

        // 校验密码
        if (isOk && Login.REPLY_LOGIN != p.oPasswordType.val()) {
            if (jQuery('#loginModel').val() == 'checkCode') {
                if (checkCode_v.length == 0) {
                    code = 'err_015'
                    isOk = false
                } else if (checkCode_v.length != 6) {
                    code = 'err_016'
                    isOk = false
                }

                /*else if (checkCode_v.length > len.checkcode_max) {
                    code = "err_016";
                    isOk = false;
                    param = len.checkcode_max;
                } else if (checkCode_v.length < len.checkcode_min) {
                    code = "err_016";
                    param = len.checkcode_min;
                    isOk = false;
                }*/
                field = 'checkcode'
            } else {
                if (password_v.length == 0) {
                    code = 'err_013'
                    isOk = false
                } else if (password_v.length > len.password_max) {
                    code = 'err_004'
                    isOk = false
                    param = len.password_max
                } else if (password_v.length < len.password_min) {
                    code = 'err_004'
                    param = len.password_min
                    isOk = false
                }
                field = 'password'
            }
        }

        //校验图片验证码
        if (isOk && !$('#li_verifyCode').is(':hidden')) {
            var vc = $('#txtVerifyCode').val()
            if (vc != undefined && vc.replace(/^\s+|\s+$/, '') == '') {
                $('#errorTips')
                    .show()
                    .html(Lang.Mail.Config.pleaseEnterImageVerificationCode)
                return false
            }
        }

        if (isOk) {
            p.setCookie()

            //TODO: 密码加密
            // RSAKey.encrypt , oPassword
            if (RSAKey && (window.top.cfgAuthMd5 == '1' || (window.top.isEncryptPwd == '1' && window.top.publicKey))) {
                p.oPassword.val(RSAKey.encrypt(p.oPassword.val(), window.top.publicKey))
            }
            return true
        } else {
            p.showError(field, code, param)
            return false
        }
    },

    showError: function(id, code, param) {
        var func = Login.func
        var msg = LEM.getErrorMsg(code, GC.getCookie('lang' + Login.sid))
        if (msg) {
            msg = msg.format(param)
            if (typeof func == 'function') {
                func(id, code, msg)
            } else {
                if (code) {
                    Login.oErrorTip.text(msg).show()
                    var pwdType = GC.getCookie(Login.USER_PWDTYPE)
                    if (pwdType == '1') {
                        TC.userDynamicPwd()
                        Login.oPassword.removeAttr('disabled').focus()
                    }
                } else {
                    Login.oErrorTip.hide()
                }
            }
        }
    },

    /**
     * 转到动态密码登录
     */
    userLogin: function() {
        var p = Login

        p.setUserLoginDisplay()
            // $('#password').show();
            // $('#mail_pswtip').show();
            // $('#checkCode').hide();
            // $('#mail_smstip').hide();
        $('#loginModel').val('')
        $('#usernumber').attr({ 'name': 'usernumber' })
            // $('#checkCode').val('');
        if (p.attrs && p.attrs['panel']) {
            var val = p.oUsernumber.val()
            p.attrs['tempMail'] = val
        }
        p.setFocus()
        p.oKeyLogin.removeClass('on')
        p.oAdminLogin.removeClass('on')
        p.oUserLogin.addClass('on')
        if (!p.oIsAdminLogin) {
            p.oLoginType.val('ADMIN')
        } else {
            p.oLoginType.val('WEB')
        }
        p.isPhoneLogin = false
        jQuery('#mail_acotip')[0].innerHTML = Lang.Mail.Config.emailAccount
        jQuery('#userNumBox').addClass('loginIpt-focus')
        jQuery('#pwdBox').removeClass('loginIpt-focus')
        jQuery('#userLoginIco')
            .removeClass('i-phone')
            .addClass('i-uid')
        jQuery('#liPwdBox').show()
        jQuery('#liCodeBox').hide()
            // jQuery("#loginModel").val("");
        if (p.isDomainMode()) {
            p.oYm.show()
        }
        p.attrs['panel'] = 1
        if (p.attrs && p.attrs['mail'] && GC.getCookie(p.REMEMBERUSER_DM) == 'true') {
            p.oUsernumber.val(p.attrs['mail'])
        } else {
            p.oUsernumber.val('')
        }
        setTimeout(function() {
            p.setNameTip()
        }, 1)
        p.oPassword.val('')
        p.oCheckCode.val('')
    },
    /**
     *管理员登陆
     */
    adminLogin: function() {
        var p = Login
        p.setAdminLoginDisplay()
            // $('#password').hide();
            // $('#mail_pswtip').hide();
            // $('#checkCode').show();
            // $('#mail_smstip').show();
        $('#errorTips').text('')
        $('#loginModel').val('checkCode')
        $('#usernumber').attr({ 'name': 'mobileNumber' })
            // $('#password').val('');
        jQuery('#mail_acotip')[0].innerHTML = Lang.Mail.Write.userTel

        //切换登陆方式避免btncode按钮值重写造成闪烁
        if (p.waitStatus) {
            $('#btncode').val(Lang.Mail.setting_phoneBindTip14)
        }
        $('#mail_smstip').html(Lang.Mail.Config.SmsCode)

        if (p.attrs && p.attrs['panel']) {
            var val = p.oUsernumber.val()
            p.attrs['tempPhone'] = val
        }

        p.oUserLogin.removeClass('on')
        p.oAdminLogin.addClass('on')
        p.setFocus()
        if (!p.oIsAdminLogin) {
            p.oLoginType.val('ADMIN')
        } else {
            p.oLoginType.val('WEB')
        }

        p.isPhoneLogin = true
        jQuery('#userNumBox').addClass('loginIpt-focus')
        jQuery('#pwdBox').removeClass('loginIpt-focus')
        jQuery('#userLoginIco')
            .removeClass('i-uid')
            .addClass('i-phone')
        jQuery('#liPwdBox').hide()
        jQuery('#liCodeBox').show()
            // jQuery("#loginModel").val("checkCode");
        if (p.isDomainMode()) {
            p.oYm.hide()
        }
        p.attrs['panel'] = 2
        if (p.attrs && p.attrs['phone'] && GC.getCookie(p.REMEMBERUSER_DM) == 'true') {
            p.oUsernumber.val(p.attrs['phone'])
        } else {
            p.oUsernumber.val('')
        }
        setTimeout(function() {
            p.setNameTip()
        }, 1)
        p.oPassword.val('')
        p.oCheckCode.val('')
    },

    /**
     * 设置焦点
     */
    setFocus: function() {
        var p = Login
        if (p.oUsernumber.val()) {
            p.oPassword.focus()
            p.oCheckCode.focus()
        } else {
            p.oUsernumber.focus()
        }
    },
    setUserLoginDisplay: function() {
        $('#liUserNum, #liPassword, #liRemeberUser, #password, #mail_pswtip').show()
        $(
                '#divIEAlertText,#divcePannel, #DevicelistDivId, #SelectUSBDivId, #liUkey, .mt_5, #checkCode, #mail_smstip'
            ).hide()
            // $("#errorTips").text("");
    },
    setAdminLoginDisplay: function() {
        $('#password,#mail_pswtip').hide()
        $('#checkCode, .mt_5, #mail_smstip').show()
            // $("#errorTips").text("");
    },

    setKeyLoginDisplay: function() {
        var p = Login

        $('#liUserNum, #liPassword, #liRemeberUser, #selectUSBUl').hide()

        p.oKeyLogin.addClass('on')
        p.oUserLogin.removeClass('on')

        $('document').bind('click', function() {
            $('#DevicelistDivId').hide()
            $('#selectUSBUl').hide()
        })

        $('#errorTips').text('')
    },
    //获取Key登录的挑战值， 赋值到页面上
    getChallenge: function(isAdmin) {
        var p = this
        var url = p.webPath + '/service/mail/ibc.do?func=mail:GenChallenge'

        if (isAdmin) {
            url = p.webPath + '/service/ibc.do?func=ibc:GenChallenge'
        }

        $.ajax({
            type: 'POST',
            url: url,
            data: {},
            dataType: 'json',
            success: function(data) {
                var challengeVal = data ? data['var'] || '' : ''

                $('#chapchallenge').val(challengeVal)
            },
            error: function(data) {
                $('#errorTips')
                    .text(Lang.Mail.Config.getChallengeValueFail)
                    .show()
            }
        })
    },
    /**
     * 转到Key登录
     */
    keyLogin: function(isAdmin) {
        var p = Login

        p.webPath = typeof gMain !== 'undefined' ? gMain.webPath || '' : ''
        p.resourcePath = typeof gMain !== 'undefined' ? gMain.resourcePath || '' : ''

        //取消用户名登录的事件绑定
        $('#login_otp').unbind('click')
        $('#KeyPassWordDiv').val('')

        p.setKeyLoginDisplay()

        if (typeof CreateKeyLoginWindows === 'function') {
            //绑定key值输入控件， 通过驱动key盘得到响应值
            CreateKeyLoginWindows('login_ul')

            $('#downUsbDriver')
                .unbind()
                .bind('click', function() {
                    location.href = p.resourcePath + '/login/download/ThinkMail_IBCSecuity.exe'
                })

            p.getChallenge(isAdmin)
        }

        if (p.attrs && p.attrs['panel']) {
            var val = p.oUsernumber.val()
            p.attrs['tempPhone'] = val
        }

        p.oLoginType.val('KEY')

        p.isKeyLogin = true

        //setTimeout(function(){p.setNameTip();},1);
    }
}

//发送短信验证码倒计时
var CountDown = {
    node: null,
    // count:(typeof(countNum) != "undefined") ? countNum : 0,
    count: 60,
    start: function() {
        if (this.count > 0) {
            Login.waitStatus = false
            this.node.value = this.count-- + Lang.Mail.Config.regetSMSVerify
            var _this = this
            setTimeout(function() {
                _this.start()
            }, 1000)
        } else {
            this.node.removeAttribute('disabled')
            this.node.value = Lang.Mail.Config.resendSMSVerify
            this.node.className = 'getCodeBtn'
                // this.count = countNum;
            this.count = 60
        }
    },
    //初始化
    init: function(node) {
        this.node = node
        this.node.setAttribute('disabled', true)
        this.start()
    }
}
var LEM = {
	DEFAULT_CODE:"err_029",
	DEFAULT_LANG:"zh_CN",
	
    getErrorMsg:function(code, lang){
        lang = lang || this.DEFAULT_LANG;
        var em = this["ERRORMSG_"+lang];
		em = em ||  this["ERRORMSG_zh_CN"];
		var msg = em[code];
		if(msg){
			return msg;
		}else{
			return em[this.DEFAULT_CODE];
		}
    },
    ERRORMSG_zh_CN: {
        "err_001": Lang.Mail.Config.loginErrorTip1,
        "err_002": Lang.Mail.Config.loginErrorTip2,
        "err_003": Lang.Mail.Config.loginErrorTip3,
        "err_004": Lang.Mail.Config.loginErrorTip4,
        "err_005": Lang.Mail.Config.loginErrorTip5,
        "err_006": Lang.Mail.Config.loginErrorTip6,
        "err_007": Lang.Mail.Config.loginErrorTip7,
        "err_009": Lang.Mail.Config.loginErrorTip9,
        "err_010": Lang.Mail.Config.loginErrorTip10,
        "err_011": Lang.Mail.Config.loginErrorTip11,
        "err_012": Lang.Mail.Config.loginErrorTip12,
        "err_013": Lang.Mail.Config.loginErrorTip13,
        "err_014": Lang.Mail.Config.loginErrorTip14,
        "err_015": Lang.Mail.Config.loginErrorTip15,
        "err_016": Lang.Mail.Config.loginErrorTip16,
        "err_028": Lang.Mail.Config.loginErrorTip28,
        "err_029": Lang.Mail.Config.loginErrorTip29,
        "err_033": Lang.Mail.Config.loginErrorTip33,
        "err_034": Lang.Mail.Config.loginErrorTip34,
        "err_035": Lang.Mail.Config.loginErrorTip35,
        "err_101": Lang.Mail.Config.loginErrorTip101,
        "err_cancel_004": Lang.Mail.Config.err_cancel_004,
        "err_lock_004": Lang.Mail.Config.err_lock_004,
        "err_notfound_004": Lang.Mail.Config.err_notfound_004,
        "err_phoneNumber_error":Lang.Mail.Config.phoneNumberError
    }
};

$(document).ready(function() {
    $('.log_tab a').click(function() {
            var i = $('.log_tab a').index(this)
            var lt = i == 1 ? 'ADMIN' : 'WEB'
            $('#loginType').val(lt)
            $(this)
                .removeClass('current')
                .siblings()
                .addClass('current')
        })
        //tab end
    var un = $('#usernumber')
    var pwd = $('#password')
    var code = $('#checkCode')
    var ckc = $('#checkcode')
    $('#mail_acotip').click(function() {
        un.focus()
    })

    /**
     * 设置登录页的界面位置
     */
    function rs() {
        var con = $('.con')
        var bh = $(window).height()
        var ct = (bh - 450) / 2
        ct = ct - 60
        if (ct < 0) ct = 0
            //老管理平台的方法
        con.css('margin-top', ct + 'px')
            //新界面居中的方法
        $('#header').css('margin-top', ct + 'px')
    }

    rs()
    $(window).resize(rs)

    /*
      un.bind("blur",function(){
      	var domain = $("#address-select").attr("sd");
      	var un_v = un.val();
      	if(un_v && domain && un_v.indexOf("@") < 0) {
      		un.val(un_v + "@" + domain);
      	}
      }); */

    $('#mail_pswtip').click(function() {
        pwd.focus()
    })
    $('#mail_smstip').click(function() {
        code.focus()
    })

    $('#mail_codetip').click(function() {
        ckc.focus()
    })

    $('#ukey_pin').on('click', function() {
        $('#KeyPassWordDiv').focus()
    })

    //password end
    function setTip() {
        if (un.val()) {
            $('#mail_acotip').hide()
        } else {
            $('#mail_acotip').show()
        }
        if (pwd.val()) {
            $('#mail_pswtip').hide()
        } else {
            $('#mail_pswtip').show()
        }
    }

    //setInterval(setTip,200);

    setTimeout(function() {
        if (un.val()) {
            // 把光标定位在最右边
            var val = pwd.value
            pwd.focus()
            pwd.value = ''
            pwd.value = val
        } else {
            un.focus()
        }
    }, 300)

    // 选项卡鼠标悬停事件
    var staticPwd
    var dynamicPwd
    $('#staticPwd').hover(
        function() {
            staticPwd = setTimeout(TC.userStaticPwd, 1)
        },
        function() {
            clearTimeout(staticPwd)
        }
    )

    $('#dynamicPwd').hover(
        function() {
            dynamicPwd = setTimeout(TC.userDynamicPwd, 1)
        },
        function() {
            clearTimeout(dynamicPwd)
        }
    )

    // 选项卡鼠标悬停事件
    var adminLogin
    var userLogin
    if (
        jQuery('#userLogin')[0] &&
        (typeof isShowMobile == 'undefined' || isShowMobile != '0')
    ) {
        $('#adminLogin').hover(
            function() {
                adminLogin = setTimeout(Login.adminLogin, 800)
            },
            function() {
                clearTimeout(adminLogin)
            }
        )

        $('#userLogin').hover(
            function() {
                userLogin = setTimeout(Login.userLogin, 800)
            },
            function() {
                clearTimeout(userLogin)
            }
        )
    }

    // 省份选择悬停事件
    var addressPop
    $('#address-select, .dropdown').hover(
        function() {
            addressPop = setTimeout(Login.showAddressPop, 800)
        },
        function(e) {
            var cn = e.relatedTarget.className
                //alert(cn+"1111");
            if (
                cn != 'address-ul clearfix addr' &&
                cn != 'address-pop' &&
                cn != 'dropdown'
            ) {
                Login.hideAddressPop()
            }
            clearTimeout(addressPop)
        }
    )

    $('.address-pop').mouseout(function(e) {
            var cn = e.relatedTarget.className

            if (cn != 'addr' && cn != 'address-ul clearfix addr') {
                //alert(cn+"2222");
                Login.hideAddressPop()
            }
        })
        //灰色皮肤去掉登录页滤镜，避免双重滤镜导致bug
    var bro = $.browser
    if (window.skinControl == 1 && bro.msie && bro.version < 9) {
        $('#login_div,.login-tabs').css('filter', '')
        $('#login_div').css('background', '#fff')
        if ($('.login-tabs').children().length == 1) {
            $('.login-tabs').attr('style', "filter:'';background:#fff")
        }
        $('.login-tabs a').css({ color: '#0033CC', filter: '', background: '#fff' })
    }
})
/***************************************************
 **        文件说明:                              **
 **      myibc.util.js                          	**
 **     Julian 2011.03.22      										**
 * 
 *  开始
 **************************************************/
/***********************************/

;;
(function(){

	var ObjUtil; //myibc.myibc.factory
	var NoUSBTip = Lang.Mail.Config.pleaseInstallUSB;
	var InitOverTextValue = Lang.Mail.Config.initCompleate;
	var AlertId = "divIEAlert";
	var AlertTextId = "divIEAlertText";
	var ChapchallengeId = "chapchallenge";	 
	var KeyPassWordId = "KeyPassWord"; 
	//提交的按钮id
	var SubmitOrCancelDivId = "SubmitOrCancelDiv";
	var webPath =  "";
	 
	
	
	//TODO START --> 从这里开始执行，加载相应的下拉框和输入框， 登陆页面加载完成后， 开始执行这个函数
	function CreateKeyLoginWindows(contentdiv){
			var KeyLoginObject = document.getElementById(contentdiv);
		    
		    webPath = gMain ? (gMain.webPath || "") : "";
		    
			if (null == KeyLoginObject){		   
			  return false;
			}
			
			var Chapchallenge = $('#'+ChapchallengeId).val();
			
			if ('undefined' === typeof(Chapchallenge)){			  
			  return false;
			}

 
				
		   //$("#divcePannel").show();	 
			
		   $("#DevicelistDivId").delegate("li", "click", function(){
		   	    $("#showDivce").text($(this).find("a").text());
		   	    $("#showDivce").attr("value", $(this).attr("value"));
		   	    $("#selectUSBUl").hide();
		   	    
		    	SelectPrivateKey();
		   });
		   
		   
		   
		   $("#divcePannel").unbind().bind("click", function(e){
		   	
		   		//点击设备下拉框，如果没有安装驱动， 顶部提示请下载安装驱动
		   		if( !IsActiveXReady() ){
		   			$("#errorTips").show().text(NoUSBTip);
		   		}else if( !CheckUSBKeyState() ){
		   			$("#errorTips").show().text(Lang.Mail.Config.pleaseInsertKeyDish);
		   		}
				
				if( $("#DevicelistDivId")[0].style.display === "none"  ){
					$("#DevicelistDivId").show();
				}else{
					$("#DevicelistDivId").hide();
				}

		   		e.stopPropagation();
		   		return false;
		   });	
		   
		   $(document).bind("click", function(){
		   		$("#DevicelistDivId").hide();
		   });
 
		   //显示私钥标识DIV

			
			   
			$("#SelectUSBDivId").unbind().bind("click", function(e){
				
				//点击设备下拉框，如果没有安装驱动， 顶部提示请下载安装驱动
		   		if( !IsActiveXReady() ){
		   			$("#errorTips").show().text(NoUSBTip);
		   		}else if( !CheckUSBKeyState() ){
		   			$("#errorTips").show().text(Lang.Mail.Config.pleaseInsertKeyDish);
		   		}
		   		
		   		if( $("#selectUSBUl")[0].style.display === "none" ){
		   			$("#selectUSBUl").show();
		   		}else{
		   			$("#selectUSBUl").hide();
		   		}
				 
				e.stopPropagation();
				return false;
			});
			
			$("#selectUSBUl").delegate("li", "click", function(){
				var txt = $(this).find("a").text();
				$("#showUsb").text( txt );
				$("#showUsb").attr("value", txt);
			});
			
			
			
			$(document).bind("click", function(){
				$("#selectUSBUl").hide();
				
			});

	      //LoginWindowObject.appendChild(document.createElement("br"));
	
	      //添加登录KEY密码DIV
//		   $("#liUkey").show();
	
		    //初始化提示文字信息divIEAlert
		    checkDiv = $('#'+AlertId).val();
		    
		    if(typeof(checkDiv) == 'undefined'){
	            
	            var AlertTextDiv = '<li  id="'+ AlertTextId +'"></li>';
				
				if(! $("#divIEAlertText")[0]) {
				    KeyLoginObject.appendChild( $(AlertTextDiv)[0]);
				}
				
			}
			
			
	        //var AlertIdObject = document.getElementById(AlertId);
	        //AlertIdObject.appendChild(AlertTextDiv);
		    //添加登录或取消按钮IDV
		   

		   var SubmitButton = $("#login_otp");
		   
		   SubmitButton.bind("click", validata_usb);

		    
	    
		 $('#divIEAlertText').html('loading...').show().slideDown("fast");
		 

		 var activeState = initActivex();
		 
		 //如果可以安装控件浏览器， 继续初始化下拉框
		//if( activeState ){
//			$("#divcePannel, #SelectUSBDivId, #liUkey").show();
			$("#liUkey").show();
			InitForm();
		//} 
		 
		if($.browser.opera){
            $("#errorTips").text(Lang.Mail.Config.safeContrlDontSupportOperaBrowser).show();
            $('#divIEAlertText').hide();
            $("#SelectUSBDivId").unbind();
            $("#divcePannel").unbind();
              $("#login_otp").unbind();
            //如果是opera浏览器
            //alert("安全控件不支持Opera浏览器,请使用IE浏览器");
            return false;
        }else if($.browser.mozilla && document.documentMode != 10 && document.documentMode != 11){
             $("#errorTips").text(Lang.Mail.Config.safeContrlDontSupportOperaFirefox).show();
             $('#divIEAlertText').hide();
             $("#SelectUSBDivId").unbind();
            $("#divcePannel").unbind();
              $("#login_otp").unbind();
            //如果是火狐浏览器
            //alert("安全控件不支持firefox,请安装IE Tab插件!");
            return false;
        }else if($.browser.safari){
             $("#errorTips").text(Lang.Mail.Config.safeContrlDontSupportOperaSafari).show();
             $('#divIEAlertText').hide();
             $("#SelectUSBDivId").unbind();
            $("#divcePannel").unbind();
            $("#login_otp").unbind();
            //如果是chrome浏览器
            //alert("安全控件不支持Safari浏览器,请使用IE浏览器");
            return false;
        }else if( !IsActiveXReady() ){
    		
             $('#divIEAlertText').html(Lang.Mail.Config.yourComputerDontInstallUSB-keyDrive).show();
             		 			 	
		 }else{
		 	$('#divIEAlertText').hide();
		 }
 
		//$("#divcePannel, #SelectUSBDivId, #liUkey").show();
		$("#liUkey").show();
		InitForm();
		
		//$('#'+AlertTextId).html('loading...').fadeIn("slow"); 
		//$('#'+AlertTextId).html(InitOverTextValue).fadeOut("slow");
		 
	}
	
	function validata_usb()
	{
		//得到响应值
		var responseData = DeviceLogin();
		var oForm = $("#login_form")[0];
			   
		if(responseData=='')
		  return false;
		  
	   //给隐藏在页面的响应值输入框赋值，提交 
	   document.getElementById("responseData").value=responseData;
	  
		oForm.method = "post";
		oForm.action = webPath + "/login/loginibc.do";
		oForm.submit();
	}
	
	//查询控件是否安装  true 安装 false 未安装
	function IsActiveXReady(){
		try{
			//如果myibc.myibc.factory存在， 说明激活的控件已经安装
			var ObjUtil = myibc.myibc.factory;
			
			if ('undefined' != typeof(ObjUtil))
			{
			    return true;
			}
			else
			{
				return false;
			}
		}
		 catch(ex)
		{
			return false;
		}
	}
	
	/**
	 *  如果有myibc对象 | 实例化插件成功并且版本不是2, 则返回true, 不需要安装驱动
	 *  否则需要安装
	 */
	function initActivex(){
		
		var isIE =navigator.userAgent.toLowerCase().search(/(msie\s|trident.*rv:)([\w.]+)/)!=-1; //检测IE11及以下
		//如果是IE浏览器
		if($.browser.msie || isIE){
		  
		  //如果已经实例化好插件的对象， 返回1	
		  if (window.myibc && myibc.myibc) {
		   	return 1;
		  }
			  
       		try {
       			//实例化驱动插件
       		   // var sharedfactory = new ActiveXObject("ATLSecurityEngine.ShareSecurityEngine");
       		    
       		    var calc = document.getElementById('Calc');
        		//result=1 代表控件可以使用，如果返回其它值则是控件不能使用，详细错误可以参考ErrorMsg.xml
        		var result = calc.GetSecurityEngine();
        		
        		if( result ==  1 ){
        			factory = calc;
	           		//factory = new ActiveXObject("ATLSecurityEngine.SecurityEngineObj");
	           		
					var version = calc.GetVersion();
	
					if (!window.myibc) {
					  myibc = {};
					}
		
					if (!myibc.myibc) {
					  //把插件实例化的对象和版本封装成另一个对象 myibc.myibc	
					  myibc.myibc = {factory: calc,info:version};
					}
        			return 1;
        		}else{
        			// calc.GetErrMsg( result )
        			$("#errorTips").show().text( calc.GetErrMsg( result ) );
        			return false;
        		}
        
           		if(!CheckUSBKeyState()){
           			$("#errorTips").show().text( NoUSBTip );
	   				//提示用户下载驱动
	   				return false;
           		}
				
   			}catch(e){
   				$("#errorTips").show().text( NoUSBTip );
   				//提示用户下载驱动
   				return false;
   		     }
 
			
            return false;
            
		}
		
		return false;
	}
	
	 /**
	  * 登录设备， 
	  * 根据pin码， 私钥值， 得到响应值
	  * 
	  */
	function DeviceLogin(){
		
		var l = $("#showDivce").attr("value");
		//得到私钥的值， 下拉选中的值
	    var privateValue = $('#showUsb').attr('value');
	    var responseData="";
	    var keyPassWord = $('#KeyPassWordDiv').val();
	    
	    l = parseInt(l, 10);
	    
		if(privateValue == 1){
			$("#errorTips").text(Lang.Mail.Config.pleaseSelectPrivateKey).show();
			return "";
		}

		
		//验证输入的秘密和Ukey pin码格式是否正确
		if (keyPassWord == ''){
			
		    // if(l===1){
		    //   $("#errorTips").show().text('文件私钥密码不能为空');
		    // }else{
		    //   $("#errorTips").show().text('UKEY PIN码不能为空');
		    // }
		    $("#errorTips").show().text(Lang.Mail.Config.UKEYPINCodeCanotBeNull);
			return "";
			
		}else if (keyPassWord.length < 4 || keyPassWord.length >=15){
			
			$("#errorTips").show().text(Lang.Mail.Config.UKEYPINCodeLengthError);
			return "";
			
		}else{
			  challengeData = $('#'+ChapchallengeId).val();
			  
			  if(challengeData.length != 32){
				$("#errorTips").show().text(Lang.Mail.Config.accessChallengeValueError);
				return false;
			  }
			  
			  ObjUtil = myibc.myibc.factory;
			  
			 if('undefined' == typeof(ObjUtil)){
				$("#errorTips").show().text( NoUSBTip );
				return "";
			 }

		 	 var returnmsg;
		 	 
			 try
			 {
				  //根据设备值， 私钥值， pin码， 得到返回的文字提示	
				  returnmsg = ObjUtil.LoginDevice(l,privateValue,keyPassWord);
				  
				  //calc.LoginDevice(1, 'demo@olymtech.net', '163');
				//如果result返回的是负值，那么说明有错误，1成功
		         if( returnmsg == 1 ){
		         	//最终获取到了响应值
		         	if( challengeData != ''){         		
		         		responseData = ObjUtil.LoginWithChap(challengeData);
		         	}
		         }else{
		         	$("#errorTips").show().text( ObjUtil.GetErrMsg(returnmsg) );
		         }  
		         
		          if ('undefined' == typeof(responseData)){
						$("#errorTips").show().text(Lang.Mail.Config.signError);
						return "";
				  }                        
				
				
				 /* if( returnmsg > 0 ){
				  	$("#errorTips").show().text('PIN 码错误，您还有' + returnmsg + '次重试次数');
				  	return false;
				  }else if(returnmsg == -2){
				  	$("#errorTips").show().text('由于您输入的错误PIN 码次数太多，该设备已经被锁住，请联系管理员');
				  	return false;	
				  }else if(returnmsg == -1){
						//最终获取到了响应值
						if(challengeData != ''){
				  		responseData = ObjUtil.LoginSystemWithChap(challengeData);
				  	}else{
				  		$("#errorTips").show().text('请刷新页面');
				  		return false;
				  	}
				  }
				  */
				 
				  
			 }catch (ex){
			   //$("#errorTips").show().text(GetErrorMessage(ex.number));
			   return "";
			 }
		 }
		    return responseData;
	 }
	
	function InitForm(){
		if(IsActiveXReady()){
			//初始化插件对usb盘的监听事件
			GetListenUSBKey();
		}else{
			$("#divIEAlertText").show();
		}
	}
	
	//处理 【连接|断开】ukey盘
	///DevicePath代表设备路径，type=1 代表设备插入， type不等于1代表设备拔出
	function OnStateChange(DevicePath,type){
	  
	  ObjUtil = myibc.myibc.factory;
	
	  $("#errorTips").text("");
	  $("#KeyPassWordDiv").val("");		 
	  
	  //1.KEY盘已经连接	
	  if(type == 1){
			
			
			
	    	//清空设备下拉列表
			ResetListDevice();
			//清空私钥下拉列表
			ResetListKey();
		
			GetDevice();
			
			return;
		}else {
			//3.1KEY被拔出时，判断是否还有KEY存在
    		var deviceString = CheckUSBKeyState();
    		
    		//如果没有key, 要清空列表
	    	if( !deviceString ){
	       		//清空设备下拉列表
				ResetListDevice();
				 //清空私钥下拉列表
				ResetListKey();

				$('#'+KeyPassWordId).val('');
				
				GetDevice();
				
				return;
			}else{
				 
				$('#'+KeyPassWordId).val('');

				return;
			}
	
		}
	}
	
	
	//清空列表
	function ResetListKey(){
 
	  $("#selectUSBUl").html("");
	  $("#showUsb").text(Lang.Mail.Config.pleaseSelectPrivateKey);
	}
	
	//清空列表
	function ResetListDevice(){

	  $("#DevicelistDivId").html("");
	  $("#showDivce").text(Lang.Mail.Config.pleaseSelectPasswordEquipment);
	}
	
	//key盘的连接状态
	function CheckUSBKeyState(){
	    try{
			  var arrayVariants = ObjUtil.GetDeviceInfo();
			  
			  if('undefined' != typeof(arrayVariants))
			  {
			  	//如果返回值为‘0;’表示未插入key
			  	if('0;;0;' == arrayVariants ){
			  	  	return false;
			  	}else{
			  		//缓存设备列表的数据
			  		myibc.myibc.info = arrayVariants;
			    
			    	return arrayVariants;
			  	}
			  	
			  	
			  }
			  else{
			       return false;
			  }
	      }catch (ex){
	         return false;
	      }
	}
	
	//监听KEY的状态
	function GetListenUSBKey(){
		   ObjUtil = myibc.myibc.factory;
		   
		   //如果找不到插件实例化的对象
		   if('undefined' == typeof(ObjUtil)){
			   $("#errorTips").show().text(NoUSBTip);
		   }
		   
		   try
		   {
				//如果UKey的状态发生变化（比如监听key盘断开连接）， 执行 OnStateChange
				ObjUtil.SetCallBack( OnStateChange );
							 
    			var deviceString = CheckUSBKeyState();
 
				//1.判断KEY是否存在
				if(deviceString){
					 
					$('#'+KeyPassWordId).val('');
					
					GetDevice();
				
					return;
				 }
				 else{
				 	
				 	$("#errorTips").show().text(Lang.Mail.Config.pleaseSelectPrivateKey);
					$('#'+KeyPassWordId).val('');
				 }
				 
			}
		   catch(ex)
		   {
			   
		      $("#errorTips").show().text( "" );
		       
		   }
	}
	
	//根据key得到的值来更新设备下拉框
	function GetDevice(){
		var ObjUtil = myibc.myibc.factory;
		  
		//如果Result返回的不是设备信息，而是数值(如-100)，那么代表调用设备接口出错
		var deviceInfoStr = ObjUtil.GetDeviceInfo(); 
	 
		
		if('undefined' == typeof(ObjUtil)){
			//插件实例化不存在
			$("#errorTips").show().text(NoUSBTip);
			return;
		}
		
		ResetListDevice();
		 
   		try{
   			
			if('undefined' != typeof(deviceInfoStr)){
				//生成设备列表
				var splitStrArray = deviceInfoStr.split(";");
				//设备数
				var deviceNum = splitStrArray[0];
				
				//循环次数为
				if( deviceNum == 4 ){
  	  				
	  	  				//(第一个设备)
	  	  				var totalprivatenum = parseInt(splitStrArray[2]);
	  	  				
						var optionvar = "";
						
						for(var i=1;i<=totalprivatenum;i++){
							optionvar = '<li rel="" value="'+  splitStrArray[2+i] +'"><a style="display:block;"  href="javascript:;">'+ splitStrArray[2+i] +'</a></li>';
						}
						  
	  	  				$("#DevicelistDivId").append(optionvar);
	  	  				
				}else{
					//多个设备
					//循环
					var pos = 1;
					
					for(var i = 0;i<deviceNum;i++){
	
						var deviceListOption = '<li rel="" value="'+  deviceNum +'"><a style="display:block;"  href="javascript:;">'+ splitStrArray[pos] +'</a></li>';
					 
							$("#DevicelistDivId").append( $(deviceListOption) );	
			
							pos++;
							
							var keyNum = splitStrArray[pos];
							
							keyNum++;
							
							pos+=parseInt(keyNum);
					}
				}
				
				$("#DevicelistDivId").find("li").eq(0).click();
				$("#DevicelistDivId").hide();
			 }
	    }
	    catch (ex)
	    {
	       	if(ObjUtil.GetErrMsg(deviceInfoStr) != ''){
	
		        $("#errorTips").show().text( ObjUtil.GetErrMsg(deviceInfoStr) );
		    }
	    }
	}
 
	
	/*
	 * 当用户选择不同设备，更新私钥下拉框
	 */
	 function SelectPrivateKey(){
	 	
		ObjUtil = myibc.myibc.factory;
	
		if('undefined' == typeof(ObjUtil)){
			$("#errorTips").show().text(NoUSBTip);
			return;
		}
 
	    //所选择的设备索引号
	   var deviceIndex = $("#showDivce").attr("value");
	   //var deviceIndex = deviceList.options[deviceList.selectedIndex].value;
	   var currSelectText = $("#showDivce").text();
	   

	   var splitStrArray = ObjUtil.GetDeviceInfo();
	   var splitArray = splitStrArray.split(';'+currSelectText+';');
		
	 
	    //当选择役备索引号不为0时，清空私钥标识然后再添加
		  //得到KEY中的IBC私钥并将所有的值取出并赋值到SelectUSB当中
		   var row = 0;
		   var col = 0;
		   var privateValue;
		   
		   //清空私钥下拉列表
		   ResetListKey();
		   
		   try{
				  var arrayVariants = splitStrArray.split(";");
				  
				  if ('undefined' != typeof(arrayVariants))
				  {
				      	//判断是否重名
				  		var selecttextcount = CountInstances(splitStrArray,currSelectText);
				  		
				  		if(selecttextcount > 1){
				  				var wenjian = splitStrArray.indexOf(Lang.Mail.Config.filePrivateKey);
								
								if(wenjian == -1){
									var pStringArray = splitArray[deviceIndex].split(";");
									var pStringNum = pStringArray[0];
								}else{
									var pStringArray = splitArray[deviceIndex-1].split(";");
									var pStringNum = pStringArray[0];
								}
								
								for(var i = 0;i<pStringNum;i++){
								  	
								  var privateKeyOption = '<li rel="" value="'+  pStringArray[i+1] +'"><a style="display:block;"  href="javascript:;">'+ pStringArray[i+1] +'</a></li>';
						 
								  $("#selectUSBUl").append( $(privateKeyOption) );
								}
								
				  		}else{
								var pStringArray = splitArray[1].split(";");
								var pStringNum = pStringArray[0];
								
								for(var i = 0;i<pStringNum;i++){
								  var privateKeyOption = '<li rel="" value="'+  pStringArray[i+1] +'"><a style="display:block;"  href="javascript:;">'+ pStringArray[i+1] +'</a></li>';
								   
								  $("#selectUSBUl").append( $(privateKeyOption) );
								  
								}
							}
  
			       $("#selectUSBUl").find("li").eq(0).click();
			       $("#selectUSBUl").hide();
			    }
			 }
		    catch (ex)
		    {
			    if(ObjUtil.GetErrMsg(splitStrArray)!=''){
		          $("#errorTips").show().text( ObjUtil.GetErrMsg(splitStrArray) );
		        }
		    }
		}
	
	
	 function CountInstances(mainStr,subStr){
		var count = 0;
		var offset = 0;
		
		do{
			offset = mainStr.indexOf(subStr, offset);
			if(offset != -1){
				count++;
				offset += subStr.length;
			}
		}while(offset != -1);
		
			return count;
	}
	
 
	
	window.CreateKeyLoginWindows = CreateKeyLoginWindows;
 

})();
;;
if(typeof constant == 'undefined'){
    constant = {};
};

(function($){
    var setPassword = {
        init: function(){
            var p = this;
            p.getWay = ""; //找回密码方式

            //点击[邮箱首页 |取消]---返回到登陆页面
            $("#mailIndex,#mailCancel").unbind().bind("click",function(){
                p.comm.goLogin();
                return false;
            });

            //点击[验证手机短信]
            $("#vdCode").unbind().bind("click",function(e){
                goPhone();
                e.stopPropagation();
                return false;
            });

            p.comm.hideAll();
            $("#choiseWay").show();


            function goPhone(){
                var p = setPassword;

                //隐藏找回方式页面，显示输入邮箱和验证码页面
                p.comm.hideAll();
                $("#vdEmail").show();
                p.comm.resetProperty();
                p.getWay = "phoneBind";

                //手机短信验证
                $("#getWayTip").html(Lang.Mail.Config.mobileSMSVerification);
                p.initEmailEvent();
            }

            //点击[验证安全问题]
            $("#vdSq").unbind().bind("click",function(e){
                goQuestion();
                e.stopPropagation();
                return false;
            });

            function goQuestion(){
                var p = setPassword;

                //隐藏找回方式页面，显示输入邮箱和验证码页面
                p.comm.hideAll();
                $("#vdEmail").show();
                p.comm.refreshImgRndCode();
                p.comm.resetProperty();
                p.getWay = "safeQuestion";

                //安全问题验证
                $("#getWayTip").html(Lang.Mail.Config.securityVerification);

                p.initEmailEvent();
            }
        },
        /**
         * 初始化邮箱、验证码页面功能
         */
        initEmailEvent: function(){
            var p 			= this;


            p.resetValue();
	
            //[邮箱账号] 先获取焦点
            $("#mailAccount").focus();

            $("#picCodeTip,#mailAccountTip").hide();

            //点击[返回]---返回到选择找回密码方式的页面
            $("#mail_back").unbind().bind("click",function(){
                $("#choiseWay").show();
                $("#vdEmail").hide();
                return false;
            });

            //点击[下一步]---验证安全问题 或者 手机绑定，跳到下一个页面（如果有安全问题||绑定手机）
            $("#mail_nextStep").unbind().bind("click",function(e){
                if(p.checkMailAccount()){
                    p.ajaxMail();
                    return false;
                }
                e.stopPropagation();
            });

            $("#mailAccount,#picCode").unbind().bind("keyup",function(e){
                var code = e.which;

                if(code == 13){
                    if(p.checkMailAccount()){
                        p.ajaxMail();
                        return false;
                        e.stopPropagation();
                    }
                }
            });

            //点击[图片||看不清楚，换一张]---更新验证码图片
            $("#imgRnd,#changeImg").unbind().bind("click",function(e){
                p.comm.refreshImgRndCode();
                e.stopPropagation();
                return false;
            });
        },
        /**
         * 检查邮箱格式是否为空、是否正确、验证码是否为空
         */
        checkMailAccount: function(){
            var p 			= this,
                mailAccount = "",
                picCode 	= "",
                codeId = "safeQuestion" == p.getWay ? "picCode_answer" : "picCode";

            mailAccount = $("#mailAccount").val();
            picCode = $("#"+codeId).val();
            p.mailAccount = mailAccount;
            p.picCode = picCode;

            $("#mailAccountTip,#picCodeTip").hide();

            //验证邮箱格式
            if(p.comm.checkEmpty(mailAccount)){
                $("#mailAccountTip").html(Lang.Mail.Config.emailAccountCanotBeNull).show();
                return false;
            }

            //验证邮箱格式
            if(!p.comm.checkData("email",$("#mailAccount").val())){
                $("#mailAccountTip").html(Lang.Mail.Config.pleaseEnterCorrectEmail).show();
                return false;
            }

            return true;
        },
        /**
         * 邮箱验证 是否有安全问题 或者 手机绑定
         */
        ajaxMail: function(){
            var p = this;

            var	data 	= {},
                p		= this,
                url 	= "",
                data 	= "",
                fnSuc	= null,
                fnFail	= null,
                sucMsg	= "",
                failMsg	= "";

            data	= {
                email: p.mailAccount
               // code : p.picCode
            };

            if(p.getWay === "phoneBind"){
                data.isPhone = true;
                p.isPhone = true;
                $("#getWayTip").html(Lang.Mail.Config.mobileSMSVerification);
            }else if(p.getWay === "safeQuestion"){
                p.isQuestion = true;
                data.isPhone = false;
                $("#getWayTip").html(Lang.Mail.Config.securityVerification);
            }

            fnSuc = function(ao){
                if(!ao){
                    p.getFailTip();
                }

                var code = ao.code,
                    msg	 = ao["var"];


                if(code === "S_OK"){

                    if(p.isPhone && msg){
                        p.mobilePhone = msg;
                        $("#vdEmail").hide();
                        $("#vdPhone").show();
                        p.initVdCodeEvent();
                        //更新样式
                        //--p.comm.changCurrent(2);
                    }else if(p.isQuestion && msg){
                        p.safeQuestion = msg;
                        $("#vdEmail").hide();
                        $("#vdQuestion").show();

                        p.initVdAnswerEvent();
                        //更新样式
                        //--p.comm.changCurrent(2);
                    }else{
                        p.getFailTip();
                    }

                }else{
                    switch (code.toUpperCase()){

                        //邮箱不存在，请重新输入
                    case "USER_NOT_FOUND":
                        $("#mailAccountTip").html(Lang.Mail.Config.emailDontExit).show();
                        break;

                        //未绑定密码安全问题，请联系管理员重置密码
                    case "QUESTION_NOT_EXIST" : 
                        $("#emailCode").hide();
                        $("#vdAll,#vdSafeQuestion").show();
                        p.comm.alert(Lang.Mail.Config.dontBindPasswordSecurity);
                        break;

                        //未开通手机短信验证码服务，请联系管理员重置密码
                    case "MOBILEPHONE_NOT_EXIST":
                        p.comm.alert(Lang.Mail.Config.dontOpenSMSVerify);
                        break;

                        //操作失败
                    default:
						// $("#mailAccountTip").html("操作失败").show();
                        p.comm.alert(Lang.Mail.Write.opFail);
                    }
					$("#mailAccount").blur();
					
					//xg
					/*
					 $("#vdEmail").hide();
					                 	 $("#vdPhone").show();
									 	 p.initVdCodeEvent();
					*/
					//xg

                }
            };

            fnFail = function(ao){

                p.getFailTip();
				

            };

            url = p.comm.url.webPath+"/service/common/validate.do?func="+p.comm.func.ValidateUserCode;

            p.comm.doService({
                type: 'POST',
                url: url,
                data: data,
                fnSuc: fnSuc,
                dataType: 'json',
                fnFail:fnFail
            });

            p.comm.refreshImgRndCode();
        },

        //获取手机号|| 安全问题失败 的提示
        getFailTip : function(){
            var p = this;

            if (p.isPhone) {
                //获取绑定手机号失败
                p.comm.alert(Lang.Mail.ConfigJs.getPhoneFail);
            }
            else {
                //获取密码安全问题失败
                p.comm.alert(Lang.Mail.Config.getSecurityVerificationCodeFail);
            }
        },

        initVdAnswerEvent: function(){
            var p = this;
			
			p.resetValue();
            $("#safeCancel").unbind().bind("click",function(e){
                goIndex();
                e.stopPropagation();
                return false;
            });
			
            $("#safeOk").unbind().bind("click",function(e){
                vdAnswer();
                e.stopPropagation();
                return false;
            });

            //点击[图片||看不清楚，换一张]---更新验证码图片
            $("#imgAnswer,#changeImg").unbind().bind("click", function (e) {
                p.comm.refreshImgRndCode("imgAnswer");
                e.stopPropagation();
                return false;
            });

            p.comm.refreshImgRndCode("imgAnswer");

            $("#txtAnswer").val("").focus();

            $("#txtSafe").html(p.safeQuestion);

            $("#txtAnswer").unbind().bind("keyup",function(e){
                vdAnswer(e.which);
                e.stopPropagation();
                return false;
            });

            function goIndex(){
                $("#vdEmail").show();
                p.comm.refreshImgRndCode();
                $("#vdQuestion").hide();
            }

            function vdAnswer(code){
                //TODO: 获取公钥
                if (window.top.isEncryptPwd == "1") {
                    RSAKey && RSAKey.getPublicKey(function (publicKey) {
                        window.top.publicKey = publicKey;
                        callback();
                    }, true);
                } else {
                    callback();
                }

                function callback(){
                    if (code) {
                        if (code == 13) {
                            if (p.checkAnswer()) {
                                p.ajaxAnswer();
                                return false;
                            }
                        }
                    } else {
                        if (p.checkAnswer()) {
                            p.ajaxAnswer();
                            return false;
                        }
                    }
                }
            }
        },
        checkAnswer: function(){
            var p = this,
                at = $("#answerTip"),
                txtAnswer = $("#txtAnswer").val(),
                codeId = "safeQuestion" == p.getWay ? "picCode_answer" : "picCode";

            p.answer = p.comm.encodeHTML(txtAnswer);
            p.picCode = $("#"+codeId).val();
            at.hide();

            if(p.comm.checkEmpty(txtAnswer)){
                at.html(Lang.Mail.ConfigJs.answerEmpty).show();
                return false;
            }

            return true;
        },
        /**
         *下一步(第二步) 提交 安全问题的答案 ajax
         */
        ajaxAnswer: function(){
            var p = this,
                fnSuc,
                fnFail,
                data = "";
            fnSuc = function(ao){
                if(!ao){
                    p.getFailTip();
                }

                var code = ao.code,
                    msg	 = ao["var"];

                if(code === "S_OK"){
                    //跳到设置密码 页面
                    $("#vdQuestion").hide();
                    $("#setNewPassword").show();
                    p.initSetPassword();
                }else{
                    p.comm.refreshImgRndCode("imgAnswer");
                    //提示：验证失败
                    switch(code.toUpperCase()){
                    case "VALIDATE_ERROR":
                        //答案错误，请重新输入
                        $("#answerTip").html(Lang.Mail.Config.answerError).show();
                        break;
                    default:
                        //验证失败
                        $("#answerTip").html(Lang.Mail.ConfigJs.autenticationFailed).show();
                    }
					p.comm.refreshImgRndCode("imgAnswer");
                }
            };

            fnFail = function(ao){
                p.getFailTip();
            };


            //TODO: 密码加密
            // RSAKey.encrypt , answer
            if (RSAKey && (window.top.cfgAuthMd5 == "1" || (window.top.isEncryptPwd == "1" && window.top.publicKey))) {
                p.answer = RSAKey.encrypt(p.answer, window.top.publicKey);
            }

            data = {
                email: p.mailAccount,
                question: p.safeQuestion,
                answer: p.answer,
                code: p.picCode
            };

            //验证安全问题
            url = p.comm.url.webPath+"/service/common/validate.do?func="+p.comm.func.ValidateUserQuestion;

            p.comm.doService({
                type: 'POST',
                url: url,
                data: data,
                fnSuc: fnSuc,
                dataType: 'json',
                fnFail:fnFail
            });
        },
		resetValue: function(){
			$("#password,#comfirmPassword,#txtAnswer,#picCode,#text,#mailAccount").val("");
		},
		toggleGetCode: function(o){
			var p = this;
			if($(o).val().trim() == ""){
				p.getcodeDisabled();
			}else{
				p.getcodeAbled();
			}
			
		},
		getcodeAbled: function(){
			var p = this;
			$("#getCode").attr("class",p.comm.className.codeNormal);
			p.initGetCode();
		},
		getcodeDisabled: function(){
			var p = this;
			$("#getCode").attr("class",p.comm.className.codeGray);
				$("#getCode").unbind("click").bind("click",function(ev){
                        ev.stopPropagation();
                        return false;
                 });
		},
        initVdCodeEvent: function(){
            var p = this,
				picCode = "",
                phone = p.mobilePhone || "";

            $("#picCode").focus();
			 $("#getCode").html(Lang.Mail.ConfigJs.getSms);
			p.resetValue();
            $("#phoneCancel").unbind().bind("click",function(){
                $("#choiseWay").show();
                $("#vdPhone").hide();
                p.clearCodeInterval();
                p.vdpwd = null;
                return false;
            });
			
			$("#picCodeTip,#msCodeTip,#getCodeTip").hide();
            //手机号码：172****5333
            phone	=  phone.toString();
           /*
			 if(phone.length > 7){
			                phone = phone.substr(0,3) + "****" + phone.substr(7);
			            }
			*/
						
            $("#txtPhone").html(phone);

            //初始化[获取验证码] 按钮
            p.initGetCode();

            $("#phoneOk").unbind().bind("click",function(e){

                checkCode();
                e.stopPropagation();
                return false;
            });

            $("#msCode").unbind().bind("keyup",function(e){
                var code = e.which;

                if(code == 13){

                    checkCode();
                    return false;
                }
            });
			
			//只有输入图片验证码，才可以点击获取短信码
			p.getcodeDisabled();
			$("#picCode").unbind().bind("keyup",function(){
				p.toggleGetCode(this);
			});
			
            function checkCode(){
                //p.clearCodeInterval();
                $("#msCodeTip").hide();
				$("#getCodeTip").hide();
                p.code = $("#msCode").val();
                //如果验证码不为空，则按手机号找回密码
                if(p.comm.checkEmpty(p.code)){
                    $("#msCodeTip").html(Lang.Mail.Config.code_check).show();
					if($("#picCode").val().trim() == ""){
						p.getcodeDisabled();
					}
                }else{
                    p.ajaxCheckCode();
                    return false;
                }
            }
        },
        goSetPass: function(){
            var p = this;

            //跳到修改密码页面
            $("#vdPhone").hide();
            $("#setNewPassword").show();
            p.initSetPassword();
        },
        /**
         *下一步(第二步) 提交 手机验证码 ajax
         */
        ajaxCheckCode: function(){
            var p = this,
                data 	= {},
                p		= this,
                url 	= "",
                data 	= "",
                vc		= $("#msCode").val();
            fnSuc	= null,
                fnFail	= null;

            p.vc = vc;
            $("#msCodeTip").hide();

            fnSuc = function(ao){
                if(!ao){
                    p.getFailTip();
                }

                var code = ao.code,
                    msg	 = ao["var"];

                if(code === "S_OK"){
                    //跳到修改密码页面
                    p.goSetPass();
                }else{

                    //提示：验证失败
                    switch(ao.code.toUpperCase()){
                    case "VALIDATECODEISEXPIRED":
                        $("#msCodeTip").html(Lang.Mail.Config.verificationCodeOverdue).show();
                        break;
                    case "VALIDATECODEISINVALID":
                        $("#msCodeTip").html(Lang.Mail.Config.invalidVerificationCode).show();
                        break;
					case "CODE_OVER_MAX_ERROR":
						$("#msCodeTip").html(Lang.Mail.Config.verificationCodeErrorTimeTooMuch).show();
						break;
                    default :
                        $("#msCodeTip").html(Lang.Mail.ConfigJs.autenticationFailed).show();
                    }

                }

            };


            data = {
                mobilePhone:p.mobilePhone,
                validateCode:p.vc
            };


            fnFail = function(ao){
				p.initGetCode();
                //提示：验证失败
                p.getFailTip();

            };

            //验证手机短信码  修改？
            url = p.comm.url.webPath+"/service/common/validate.do?func="+p.comm.func.ValidateMobileCode;

            p.comm.doService({
                type: 'POST',
                url: url,
                data: data,
                fnSuc: fnSuc,
                dataType: 'json',
                fnFail:fnFail
            });

        },
        /**
         * 初始设置新密码页面事件
         */
        initSetPassword: function(){
            var p = this;

            $("#newPassword").focus();
			p.resetValue();
            $("#cancelPass").unbind().bind("click",function(){
                goIndex();
                return false;
            });

            function goIndex(){
                p.comm.hideAll();
                $("#choiseWay").show();
            }

            $("#savePass").unbind().bind("click",function(e){
                if (p.checkPass()) {
                    //TODO: 获取公钥
                    if (window.top.isEncryptPwd == "1") {
                        RSAKey && RSAKey.getPublicKey(function (publicKey) {
                            window.top.publicKey = publicKey;
                            p.ajaxSetPass();
                        }, true);
                    } else {
                        p.ajaxSetPass();
                    }
                    return false;
                }
                e.stopPropagation();
            });

            $("#newPassword,#comfirmPassword").unbind().bind("keyup",function(e){
                var code = e.which;
                $("#newPasswordTip").hide();
                $("#comfirmPasswordTip").hide();
                if(code == 13){
                    if (p.checkPass()) {
                        //TODO: 获取公钥
                        if (window.top.isEncryptPwd == "1") {
                            RSAKey && RSAKey.getPublicKey(function (publicKey) {
                                window.top.publicKey = publicKey;
                                p.ajaxSetPass();
                            }, true);
                        } else {
                            p.ajaxSetPass();
                        }
                        return false;
                    }
                }
            });


            if($("#secGrade")[0]){
                $("#secGrade").remove();
            }

            var NotContains = {
                Account: "",
                Mobile: '',
                Alias: ''
            };
            var obj = {
                "pwdId": "newPassword",
                "NotContains": NotContains,
                "sLevel":parseInt(constant.pwdCheckType,10) || 1,
                "pwdMaxLen": ~~constant.pwdMaxLen || 30,
                "pwdMinLen": ~~constant.pwdMinLen || 6,
                "wrapClassName":"pl155",
                "wrapTagName":"div",
                "contId": "checkPassStrengthTip"
            };
            // 增加密码强度验证插件的容器
            if ($("#checkPassStrengthTip").length < 1) {
                $('<span class="red fz_12" id="checkPassStrengthTip"></span>').insertAfter("#newPasswordTip");
            }
            p.vdpwd = new VdPassWord(obj);
            $("#strPassLen").html((~~constant.pwdMinLen || 6) + "-" +(~~constant.pwdMaxLen || 20));


        },
        initGetCode: function(){
            var p = this;
			
            $("#getCode").unbind().bind("click",function(e){
                p.getCode();
                e.stopPropagation();
                return false;
            });
        },

        ajaxSetPass: function(){
            var p = this,
                fnSuc,
                fnFail,
                data = "";

            $("#newPasswordTip").hide();
            $("#comfirmPasswordTip").hide();
            $("#checkPassStrengthTip").hide();

            fnSuc = function(ao){
                if(!ao){
                    p.getFailTip();
                }

                var code = ao.code,
                    msg	 = ao["var"];

                if(code === "S_OK"){
                    //跳到修改密码成功页面
                    p.goPassSuc();
                }else{
                    //提示：验证失败
                    switch(code.toUpperCase()){
                    case "WEAK_PWD":
                        $("#newPasswordTip").html(Lang.Mail.Config.passwordNotSafe).show();
                        break;
                    case "INVALID_PWD":
                        $("#newPasswordTip").html(Lang.Mail.Config.passwordDonotMeetSpecification).show();
                        break;
                    case "INVALID_PWD_NEW":
                        $("#newPasswordTip").html(Lang.Mail.Config.systemForbidUseFirst3Times).show();
                        break;
                    default:
                        p.comm.alert(Lang.Mail.Config.setPasswordFail);
                    }
                }


            };

            fnFail = function(ao){
                //提示：验证失败
                p.getFailTip();
            };

          /*
			  data = {
			                phone:p.isPhone,  //如果为false说明是验证安全问题
			                mobilePhone:p.mobilePhone,
			                validateCode:p.vc,
			                email:p.mailAccount,
			                question:p.safeQuestion,
			                answer:p.answer,
			                password:p.password
			            };
			*/

            //TODO: 密码加密
            // RSAKey.encrypt , oPassword
            if (RSAKey && (window.top.cfgAuthMd5 == "1" || (window.top.isEncryptPwd == "1" && window.top.publicKey))) {
                p.password = RSAKey.encrypt(p.password, window.top.publicKey);
            }

			data = {
				password:p.password
			};


            //修改密码   /mail/service/common/validate.do?func= common: UpdateUserPassword
            url = p.comm.url.webPath+"/service/common/validate.do?func="+p.comm.func.UpdateUserPassword;

            p.comm.doService({
                type: 'POST',
                url: url,
                data: data,
                fnSuc: fnSuc,
                dataType: 'json',
                fnFail:fnFail
            });

        },
        /**
         * 跳到修改密码成功页面
         */
        goPassSuc : function(){
            var p = this;
            p.vdpwd = null;

            $("#setPassSuc").show();
            $("#setNewPassword").hide();
            p.initPassSuc();
        },
        initPassSuc: function(){
            var p = this;
			
            $("#newLogin").unbind().bind("click",function(e){
                p.comm.goLogin();
                e.stopPropagation();
                return false;
            });

            if(p.isPhone){
                $("#topTip").html(Lang.Mail.Config.mobileSMSVerify);
            }else if(p.isQuestion){
                $("#topTip").html(Lang.Mail.Config.safeAnswerVerify);
            }
        },
        checkPass: function(){
            var p	= this,
                np	= $("#newPassword").val(),
                cp	= $("#comfirmPassword").val(),
                nt	= $("#newPasswordTip"),
                ct	= $("#comfirmPasswordTip");

            nt.hide();
            ct.hide();

            if(parseInt(p.vdpwd.NotifyCode,10) !== 0){
                nt.html(p.vdpwd.msg).show();
                return false;
            }

            if(p.comm.checkEmpty(cp)){
                ct.html(Lang.Mail.Config.confirmPasswordCannotBeEmpty).show();
                return false;
            }

            if(np !== cp){
                ct.html(Lang.Mail.Config.passwordsDontMatch).show();
                return false;
            }

            p.password = np;
            return true;
        },

        /**
         * 获取验证码
         */
        getCode :function(){
            var p   		= this,
                $			= jQuery,
                $getvdCode	= $("#getCode");

            //59秒后可重新获取
            p.codeHtml = "<var id=\"codeSec\">60</var>"+Lang.Mail.Config.getSMSVerify,
                i		 = 60;
			
			if(!p.checkCodePic()){
				return;
			}
            p.ajaxGetCode();

            //p.ajaxRequest("getCode",data,fnSuc,fnFail)


        },
		checkCodePic: function(){
			var p = this,
                way = p.getWay,
                codeId = "safeQuestion" == way ? "picCode_answer" : "picCode",
				picCode = $("#"+codeId).val().trim();
			
			$("#msCodeTip").hide();	
			p.picCode = picCode;	
			//验证是否有验证码
            if(p.comm.checkEmpty(picCode)){
                $("#picCodeTip").html(Lang.Mail.ConfigJs.imgEmp).show();
                return false;
            }
			return true;
		},
        setCodeInterval: function(){
            var p   		= this,
                $			= jQuery,
				i			= 59,
                $getvdCode	= $("#getCode");

            p.timer = setInterval(function(){

                if(i){

                    //每一秒变化一次
                    $("#codeSec").html(i--);

                    //60秒内不能再次获取短信验证码
                    $getvdCode.unbind("click").bind("click",function(ev){
                        ev.stopPropagation();
                        return false;
                    });
                }else{
                    //重新获取验证码
                    anewSpan = "<span id=\"\">"+Lang.Mail.Config.regetSMSVerify+"</span>";
                    $("#getCode").attr("class",p.comm.className.codeNormal);
                    $getvdCode.html(anewSpan);

                    p.clearCodeInterval();

                    //设置[获取验证码] 按钮为可点击
                    p.initGetCode();
                }
            },1000);
        },
        clearCodeInterval: function(){
            var p = this;
            if(p.timer){
                clearInterval(p.timer);
                p.timer = null;
            }

            $("#getCode").html(Lang.Mail.Config.resendSMSVerify);
            $("#getCode").attr("class",p.comm.className.codeNormal);
			p.initGetCode();
        },
        /**
         * 获取手机验证码 ajax
         */
        ajaxGetCode: function(){
            var p   		= this,
                $			= jQuery,
                data		= {mobilePhone:p.mobilePhone,code: p.picCode},
                fnSuc		= null,
                fnFail	 	= null,
                $getvdCode	= $("#getCode");
			
			$("#getCodeTip,#picCodeTip").hide();
            fnSuc = function(data){
				if(data.code.toUpperCase() == "S_OK"){
					 //提示：60秒后重获验证码
               	 	$getvdCode.html(p.codeHtml);

               	 	p.getcodeDisabled();

               		 p.setCodeInterval();
					 
					 $("#msCode").focus();
				}else if(data.code.toUpperCase() == "INVALID_VERIFY_CODE"){
					$("#picCodeTip").text(Lang.Mail.Config.imageVerifyError).show();
                    p.comm.refreshImgRndCode();
				}else{
					p.initGetCode();
					$("#getCodeTip").text(Lang.Mail.ConfigJs.getSmsFail).show();
                    p.comm.refreshImgRndCode();
				}
                
            };
            fnFail = function(){
				p.initGetCode();
                $("#getCodeTip").text(Lang.Mail.ConfigJs.getSmsFail).show();
				p.comm.refreshImgRndCode();
            };

            //mail/service/common/validate.do?func= common: GetMobileValidateCode
            url = p.comm.url.webPath+"/service/common/validate.do?func="+p.comm.func.GetMobileValidateCode;

            p.comm.doService({
                type: 'POST',
                url: url,
                data: data,
                fnSuc: fnSuc,
                fnFail: fnFail,
                dataType: 'json'
            });
        },
        /**
         * 各页面公用的方法
         * @param {Object} $obj
         */
        comm: {
            drag: function(obj,zIndex){
                obj.onmousedown = function(e){
                    var ev = e || event;
                    var x = ev.clientX;
                    var y = ev.clientY;
                    var disX = x - obj.offsetLeft - 176;
                    var disY = y - obj.offsetTop - 70;
                    var d = document;
                    var win = window;

                    obj.style.position = "absolute";

                    if(zIndex){
                        obj.style.zIndex = ++zIndex;
                    }


                    if(obj.setCapture){
                        obj.setCapture();
                    }else if(win.captureEvents){
                        win.captureEvents(ev.MOUSEMOVE );
                    }

                    d.onmousemove = function(e){
                        var ev = e || event;
                        obj.style.left = ev.clientX - disX + "px";
                        obj.style.top = ev.clientY - disY + "px";
                    };
                    d.onmouseup = function(){
                        if(obj.releaseCapture){
                            obj.releaseCapture();
                        }else if(win.captureEvents){
                            win.releaseEvents(ev.MOUSEMOVE );
                        }

                        d.onmousemove = null;
                        d.onmouseup = null;
                    };
                    return false;
                };
            },
            goBack: function($obj){
                $obj.click(function(){
                    //
                    window.location.go(-1);
                    return false;
                });
            },
            /**
             * 重置各属性值
             */
            resetProperty: function(){
                var p = setPassword;

                p.isPhone = false;
                p.isQuestion = false;
                p.mobilePhone = "";
                p.picCode = "";
                p.mailAccount = "";
                p.safeQuestion = "";
                p.answer = "";
            },
            /**
             * 跳到邮箱的登陆页
             */
            goLogin : function(){
                //${contexPath}换
                window.location.href = constant.webPath + "/login/login.do";
            },
            hideAll: function(){
                $("#choiseWay,#vdEmail,#vdPhone,#vdQuestion,#setNewPassword,#setPassSuc").hide();
            },
            alert: function(msg,w,h){
                var d = $("#dialog"),
                    m = $("#mask"),
                    p = setPassword;

                $("#picCode").blur();

                d.show();
                m.show();

                p.comm.drag($("#dialog")[0]);

                $("#closeDialog,#dialogOk").click(function(){
                    d.hide();
                    m.hide();
                });
                $("#dContent").html(msg);

                if(w){
                    d.css("width",w);
                }
                if(h){
                    d.css("height",h);
                }

                $(document).keyup(function(e){
                    if(e.which == 13){
                        d.hide();
                        m.hide();
                        return false;
                    }
                });
            },
            func: {
                ValidateUserCode:"common:ValidateUserCode",
                GetUserSecurityConf:"mail:GetUserSecurityConf",
                ValidateMobileCode:"common:ValidateMobileCode",       //验证短信码
                GetMobileValidateCode:"common:GetMobileValidateCode", //获取手机验证码
                UpdateUserPassword:"common:UpdateUserPassword",       //设置新密码
                ValidateUserQuestion:"common:ValidateUserQuestion" //验证安全问题的答案
            },
            className: {
                codeNormal:"secondBtn",      //[获取验证码] 按钮默认的样式
                codeGray: "secondBtn_un"	 //[获取验证码] 按钮变成灰色的样式
            },

            url: {
                webPath: constant.webPath //需要修改
            },
            /**
             * 改变顶部[第几步]的图片
             * @param {Object} index
             */
            changCurrent: function(index){
                $("#topStep")[0].src = "images/step"+index+".jpg";
            },
            checkEmpty: function(str){
                if(/^\s*$/.test(str)){
                    return true;
                }
                return false;
            },
            /**
             * 验证手机
             */
            checkPhone : function(bBlur){

            },
            encodeHTML: function(s) {

                s = s.replace(/&/g, "&amp;");
                s = s.replace(/</g, "&lt;");
                s = s.replace(/>/g, "&gt;");
                s = s.replace(/\"/g, "&quot;");
                s = s.replace(/ /g, "&nbsp;");
                s = s.replace(/\'/g, "&#39;");
                return s;
            },
            checkMobile : function(str){
                var reg = /^(86)?((13[4-9]{1})|(15[0-2 7-9]{1})|(18[2 7-8]{1}))+\d{8}$/;
                return reg.test(str);
            },
            /***
             * 检查数据
             * @param {Object} dt 数据类型
             * @param {Object} str 数据
             * @param {Object} regStr 字符串
             */
            checkData : function(dt,str,regStr){
                str = str.toString().replace(/^\s+|\s+$/,"");
                var reg = "";
                switch(dt) {
                case "email":
                    reg = /^([A-Z0-9._%-]{1,255})@[A-Z0-9._%-]+\.[A-Z0-9]{1,4}$/i;
                    break;
                case "mobile":
                    reg = /^(0?86)?1[\d]{10}$/i;
                    break;
                case "phone":
                    reg = /^0[\d]{2,3}[\d]{7,8}$/i;
                    break;
                case "empty":
                    reg = /^.+/i;
                    break;
                case "number":
                case "int":
                    reg = /^[0-9]+$/i;
                    break;
                case "domain":
                    reg = /^[A-Z0-9._%-]+\.[A-Z0-9]{1,4}$/i;
                    break;
                case "blackDomain":
                    reg = /^(\*@)[A-Z0-9._%-]+\.[A-Z0-9]{1,4}$/i;
                    break;
                case "*@domain":
                    reg = /^(\*@)[A-Z0-9._%-]+\.[A-Z0-9]{1,4}$/i;
                    break;
                case "@domain":
                    reg = /^(@)[A-Z0-9._%-]+\.[A-Z0-9]{1,4}$/i;
                    break;
                case "port":
                    if(str>0 && str<65535){
                        return true;
                    }else{
                        return false;
                    }
                    break;
                case "reg":
                    reg = regStr;
                    break;
                case "custom":
                    reg = new RegExp(regStr,"gi");
                    break;
                }
                try{
                    if (reg) {
                        return reg.test(str);
                    }else{
                        return false;
                    }
                }catch(e){
                    return false;
                }
            },

            doService: function(obj){
                $.ajax({
                    type: obj.type || 'POST',
                    url: obj.url || "",
                    data: JSON.stringify(obj.data),
                    dataType: 'json',
                    contentType:"text/javascript; charset=UTF-8",
                    success: obj.fnSuc,
                    error: obj.fnFail

                });
            },
            refreshImgRndCode: function(id){
                id = id || "imgRnd";
                $("#"+ id)[0].src = constant.imgUrl + "?r=" + new Date().getTime();
            },
            /**
             * 输入框获取焦点，离开焦点，默认值处理
             * @param {Object} $obj 输入框
             * @param {Object} defaut 默认值
             */
            defautEvent: function($obj,defautValue){
                $obj.focus(function(){
                    if(this.value.replace(/^\s+|\s+$/,"") === defautValue){
                        $(this).val("");
                    }
                });
                $obj.blur(function(){
                    if(this.value.replace(/^\s+|\s+$/,"") === ""){
                        $(this).val(defautValue);
                    }
                });
            }
        }

    };

    window.setPassword = setPassword;
})(jQuery);

setPassword.init();
		

